import React, { useState, useContext, useEffect, useRef, useCallback, useMemo } from 'react';
import { AuthContext } from '../../components/AuthContext';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FaTrash, FaCaretUp, FaCaretDown, FaTimes, FaPlus, FaSearch, FaFilter, FaSortUp, FaSortDown, FaAngleLeft, FaAngleRight, FaAngleDoubleLeft, FaAngleDoubleRight, FaChartBar, FaCalendarAlt, FaPrint, FaFileDownload, FaEdit, FaEye, FaCopy, FaPaste, FaWhatsapp } from 'react-icons/fa';
import Select from 'react-select';
import Swal from 'sweetalert2';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useDebounce } from 'use-debounce';
import MasterSelection from '../../components/MasterSelection';

// Enhance your formatId function to be more robust
const formatId = (id) => {
  if (id === null || id === undefined) return '';
  
  // If it's already a string, return it
  if (typeof id === 'string') return id;
  
  // Handle different object formats
  if (typeof id === 'object') {
    // For MongoDB ObjectId representation
    if (id.number !== undefined) return String(id.number);
    if (id._id !== undefined) return String(id._id);
    if (id.id !== undefined) return String(id.id);
    
    // For numeric values that might be objects
    if (id.toString && typeof id.toString === 'function') {
      return id.toString();
    }
    
    // Last resort - try to stringify
    try {
      return JSON.stringify(id);
    } catch (e) {
      return '[Object]';
    }
  }
  
  // For any other type, convert to string
  return String(id);
};

// Add this helper to safely display any value in your JSX
const safeDisplay = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch (e) {
      return '[Object]';
    }
  }
  return String(value);
};

// Add near the top of your component
const debugApiResponse = (response, label = "API Response") => {
  console.group(label);
  console.log("Status:", response.status);
  console.log("Headers:", response.headers);
  console.log("Data:", response.data);
  console.groupEnd();
};

// Component definition
const TallyQuotation = () => {
    // Replicate item handler
    const replicateItem = (sectionIdx, itemIdx) => {
      setForm(prevForm => {
        const newForm = JSON.parse(JSON.stringify(prevForm));
        const section = newForm.sections[sectionIdx];
        const itemToClone = section.items[itemIdx];
        const clonedItem = { ...itemToClone };
        section.items.splice(itemIdx + 1, 0, clonedItem);
        return newForm;
      });
    };
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');
  const [viewMode, setViewMode] = useState('list');
  // State management
  const [form, setForm] = useState({
    recipient: null,
    recipientType: 'Customer',
    siteAddress: '', // New field for optional site address
    salesmen: [],
    sections: [{
      name: '',
      items: [{
        item: '',
        itemName: '',
        customName: '',
        applicationArea: '',
        boxes: 1,
        pieces: 0,
        quantity: 1,
        unit: 'pcs',
        listedPrice: 0, // renamed from rate
        listedPriceTotal: 0,
        offerPrice: 0,
        offerPriceTotal: 0,
        discount: 0,
        coverageArea: 0,
        coverageAreaUnit: 'sqft'
      }],
      listedPriceTotal: 0,
      offerPriceTotal: 0,
    }],
    listedPriceGrandTotal: 0,
    offerPriceGrandTotal: 0,
    reference: null,
    referenceName: '',
    transporterName: null,
    transporterDisplayName: '',
    remarks: '',
    createdBy: user?.user?._id,
    createdAt: new Date().toISOString(),
    cartage: 0,
    packingAndForwarding: 0,
    labour: 0,
    roundOff: 0,
    totalAmount: 0
  });
  // Basic state for customers, dealers, etc.
  const [customers, setCustomers] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [references, setReferences] = useState([]);
  const [transporters, setTransporters] = useState([]);
  const [tallyItems, setTallyItems] = useState([]);
  const [employees, setEmployees] = useState([]);
  // Pagination states
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);
  // Modal states
  const [modalVisible, setModalVisible] = useState({ open: false, func: null });
  const [edit, setEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [quotations, setQuotations] = useState([]);
  const [quotationPage, setQuotationPage] = useState(1);
  const [quotationLimit, setQuotationLimit] = useState(5); // Add this line
  const [totalQuotations, setTotalQuotations] = useState(0);// Add this line
  // Refs
  const inputRef = useRef(null);
  const sectionNameRefs = useRef([]);
  // State to track which input should be focused
  const [focusTarget, setFocusTarget] = useState(null);
  // Additional states for statistics and filters
  const [statsLoading, setStatsLoading] = useState(false);
  const [quoteStats, setQuoteStats] = useState(null);
  const [lastSevenDaysStats, setLastSevenDaysStats] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedSearch] = useDebounce(searchQuery, 500);
  const [advancedFilters, setAdvancedFilters] = useState({
    recipientType: '',
    startDate: null,
    endDate: null,
    minAmount: '',
    maxAmount: '',
    salesmanId: ''
  });
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [selectedQuotation, setSelectedQuotation] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showRecipientModal, setShowRecipientModal] = useState(false);
  const [showReferenceModal, setShowReferenceModal] = useState(false);
  const [showTransporterModal, setShowTransporterModal] = useState(false);
  const [showItemDetailsModal, setShowItemDetailsModal] = useState(false);
  const [selectedItemForDetails, setSelectedItemForDetails] = useState(null);
  
  // Choice import states
  const [showChoiceImportModal, setShowChoiceImportModal] = useState(false);
  const [choices, setChoices] = useState([]);
  const [selectedChoices, setSelectedChoices] = useState([]);
  const [choiceSearch, setChoiceSearch] = useState('');
  const [choicePage, setChoicePage] = useState(1);
  const [totalChoicePages, setTotalChoicePages] = useState(1);
  const [loadingChoices, setLoadingChoices] = useState(false);
  const [importingSectionName, setImportingSectionName] = useState('');
  const [copiedItem, setCopiedItem] = useState(() => {
    try {
      const saved = localStorage.getItem('tally_quotation_clipboard_item');
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });
  const [copiedSection, setCopiedSection] = useState(() => {
    try {
      const saved = localStorage.getItem('tally_quotation_clipboard_section');
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });

  // Sync dark mode with localStorage
  useEffect(() => {
    const interval = setInterval(() => {
      const savedMode = localStorage.getItem('darkMode');
      setIsDarkMode(savedMode === 'true');
    }, 500);
    return () => clearInterval(interval);
  }, []);

  // Dark mode: CSS injection for inputs/selects/labels/etc.
  useEffect(() => {
    const styleId = 'tally-quotation-dark-mode-css';
    let el = document.getElementById(styleId);
    if (isDarkMode) {
      if (!el) {
        el = document.createElement('style');
        el.id = styleId;
        document.head.appendChild(el);
      }
      el.textContent = `
        .tq-dark-page input:not([type=checkbox]):not([type=radio]) {
          background-color: #374151 !important; border-color: #4b5563 !important; color: #f3f4f6 !important;
        }
        .tq-dark-page input:not([type=checkbox]):not([type=radio])::placeholder { color: #9ca3af !important; }
        .tq-dark-page input:not([type=checkbox]):not([type=radio]):focus {
          border-color: #60a5fa !important; box-shadow: 0 0 0 2px rgba(96,165,250,0.2) !important; background-color: #374151 !important;
        }
        .tq-dark-page textarea {
          background-color: #374151 !important; border-color: #4b5563 !important; color: #f3f4f6 !important;
        }
        .tq-dark-page textarea::placeholder { color: #9ca3af !important; }
        .tq-dark-page textarea:focus { border-color: #60a5fa !important; box-shadow: 0 0 0 2px rgba(96,165,250,0.2) !important; }
        .tq-dark-page label { color: #d1d5db !important; }
        .tq-dark-page select { background-color: #374151 !important; border-color: #4b5563 !important; color: #f3f4f6 !important; }
        .tq-dark-page select:focus { border-color: #60a5fa !important; box-shadow: 0 0 0 2px rgba(96,165,250,0.2) !important; }
        .tq-dark-page .react-datepicker-wrapper input { background-color: #374151 !important; color: #f3f4f6 !important; border-color: #4b5563 !important; }
        .tq-dark-page .react-datepicker { background-color: #1f2937 !important; border-color: #4b5563 !important; color: #f3f4f6 !important; }
        .tq-dark-page .react-datepicker__header { background-color: #374151 !important; border-color: #4b5563 !important; }
        .tq-dark-page .react-datepicker__current-month, .tq-dark-page .react-datepicker__day-name { color: #f3f4f6 !important; }
        .tq-dark-page .react-datepicker__day { color: #d1d5db !important; }
        .tq-dark-page .react-datepicker__day:hover { background-color: #4b5563 !important; }
        .tq-dark-page .react-datepicker__day--selected { background-color: #3b82f6 !important; color: white !important; }
        .tq-dark-page .react-datepicker__day--keyboard-selected { background-color: #2563eb !important; color: white !important; }
        .tq-dark-page .css-1nmdiq5-menu, .tq-dark-page [class*="-menu"] { background-color: #1f2937 !important; border-color: #4b5563 !important; }
        .tq-dark-page [class*="-option"] { color: #f3f4f6 !important; }
        .tq-dark-page [class*="-option"]:hover, .tq-dark-page [class*="-option--is-focused"] { background-color: #374151 !important; }
        .tq-dark-page .text-red-500 { color: #f87171 !important; }
        .tq-dark-page .text-blue-600:not(.tq-skip-dark) { color: #60a5fa !important; }
        .tq-dark-page .text-orange-600 { color: #fb923c !important; }
        .tq-dark-page .text-green-600:not(.tq-skip-dark) { color: #4ade80 !important; }
        .tq-dark-page .border-red-300 { border-color: #991b1b !important; }
        .tq-dark-page [class*="bg-red-50"] { background-color: rgba(127,29,29,0.2) !important; }
        .tq-dark-page .border-orange-300 { border-color: #9a3412 !important; }
        .tq-dark-page .border-green-300 { border-color: #166534 !important; }
        .tq-dark-page [class*="swal2"] { background-color: #1f2937 !important; color: #f3f4f6 !important; }
        /* Modal inner elements dark mode */
        .tq-dark-page .tq-modal-card .bg-white { background-color: #1f2937 !important; }
        .tq-modal-dark .bg-white { background-color: #1f2937 !important; }
        .tq-modal-dark .bg-gray-50 { background-color: #374151 !important; }
        .tq-modal-dark .border-gray-200, .tq-modal-dark .border-gray-100 { border-color: #4b5563 !important; }
        .tq-modal-dark .text-gray-500 { color: #9ca3af !important; }
        .tq-modal-dark .text-gray-700 { color: #d1d5db !important; }
        .tq-modal-dark .text-gray-800 { color: #f3f4f6 !important; }
        .tq-modal-dark .text-gray-900 { color: #f9fafb !important; }
        .tq-modal-dark .font-medium { color: #e5e7eb; }
        .tq-modal-dark table { border-color: #4b5563 !important; }
        .tq-modal-dark thead { background-color: #374151 !important; }
        .tq-modal-dark tbody tr { border-color: #4b5563 !important; }
        .tq-modal-dark tbody tr:nth-child(even) { background-color: #1e293b !important; }
        .tq-modal-dark tbody tr:nth-child(odd) { background-color: #1f2937 !important; }
        .tq-modal-dark td, .tq-modal-dark th { border-color: #4b5563 !important; color: #e5e7eb !important; }
        .tq-modal-dark .divide-gray-200 > :not([hidden]) ~ :not([hidden]) { border-color: #4b5563 !important; }
        .tq-modal-dark .divide-gray-100 > :not([hidden]) ~ :not([hidden]) { border-color: #374151 !important; }
        .tq-modal-dark .border-gray-300 { border-color: #4b5563 !important; }
        .tq-modal-dark .text-gray-600 { color: #9ca3af !important; }
        .tq-modal-dark .text-gray-400 { color: #6b7280 !important; }
        /* Badge overrides in dark modal */
        .tq-modal-dark .bg-purple-100 { background-color: rgba(147,51,234,0.2) !important; }
        .tq-modal-dark .text-purple-800 { color: #c084fc !important; }
        .tq-modal-dark .bg-green-100 { background-color: rgba(34,197,94,0.15) !important; }
        .tq-modal-dark .text-green-800 { color: #86efac !important; }
        .tq-modal-dark .bg-blue-100 { background-color: rgba(59,130,246,0.15) !important; }
        .tq-modal-dark .text-blue-800 { color: #93c5fd !important; }
        .tq-modal-dark .bg-gray-100 { background-color: #374151 !important; }
        .tq-modal-dark .text-gray-300 { color: #d1d5db !important; }
        /* Buttons in dark modal */
        .tq-modal-dark .bg-indigo-50 { background-color: rgba(99,102,241,0.15) !important; }
        .tq-modal-dark .text-indigo-700 { color: #a5b4fc !important; }
        .tq-modal-dark .border-indigo-200 { border-color: rgba(99,102,241,0.3) !important; }
        .tq-modal-dark .hover\\:bg-indigo-100:hover { background-color: rgba(99,102,241,0.25) !important; }
        .tq-modal-dark .hover\\:border-indigo-300:hover { border-color: rgba(99,102,241,0.4) !important; }
        /* Gradient/bg overrides in dark modal */
        .tq-modal-dark .bg-gradient-to-r.from-gray-50 { background: #374151 !important; }
        .tq-modal-dark .from-gray-50.to-gray-100 { background: #374151 !important; }
        .tq-modal-dark .bg-blue-50 { background-color: rgba(59,130,246,0.1) !important; }
        .tq-modal-dark .text-blue-600 { color: #60a5fa !important; }
        /* Hover row override - override inline bg classes */
        .tq-modal-dark tbody tr.bg-white { background-color: #1f2937 !important; }
        .tq-modal-dark tbody tr.bg-gray-50 { background-color: #1e293b !important; }
        .tq-modal-dark tbody tr:hover { background-color: #374151 !important; background: #374151 !important; }
        /* Footer and pagination */
        .tq-modal-dark .hover\\:bg-gray-50:hover { background-color: #374151 !important; }
        .tq-modal-dark .bg-yellow-50 { background-color: rgba(234,179,8,0.1) !important; }
        .tq-modal-dark .text-yellow-800 { color: #fde047 !important; }
        .tq-modal-dark .border-yellow-200 { border-color: rgba(234,179,8,0.3) !important; }
        .tq-modal-dark .border-blue-200 { border-color: rgba(59,130,246,0.3) !important; }
        .tq-modal-dark .text-blue-700 { color: #93c5fd !important; }
        /* Broad Tailwind utility overrides for dark mode on main page */
        .tq-dark-page .text-gray-500:not(.tq-skip-dark) { color: #9ca3af !important; }
        .tq-dark-page .text-gray-600:not(.tq-skip-dark) { color: #9ca3af !important; }
        .tq-dark-page .text-gray-700:not(.tq-skip-dark) { color: #d1d5db !important; }
        .tq-dark-page .text-gray-800:not(.tq-skip-dark) { color: #e5e7eb !important; }
        .tq-dark-page .text-gray-900:not(.tq-skip-dark) { color: #f3f4f6 !important; }
        .tq-dark-page .bg-gray-50:not(.tq-skip-dark) { background-color: #374151 !important; }
        .tq-dark-page .bg-gray-100:not(.tq-skip-dark) { background-color: #374151 !important; }
        .tq-dark-page .bg-white:not(.tq-skip-dark) { background-color: #1f2937 !important; }
        .tq-dark-page .border-gray-100 { border-color: #374151 !important; }
        .tq-dark-page .border-gray-200 { border-color: #4b5563 !important; }
        .tq-dark-page .border-gray-300 { border-color: #4b5563 !important; }
        .tq-dark-page .hover\\:bg-gray-50:hover { background-color: #374151 !important; }
        .tq-dark-page .hover\\:bg-gray-100:hover { background-color: #374151 !important; }
        .tq-dark-page .hover\\:bg-blue-50:hover { background-color: #1e3a5f !important; }
        .tq-dark-page .hover\\:text-gray-700:hover { color: #d1d5db !important; }
        .tq-dark-page .divide-gray-200 > :not([hidden]) ~ :not([hidden]) { border-color: #4b5563 !important; }
        .tq-dark-page .divide-gray-100 > :not([hidden]) ~ :not([hidden]) { border-color: #374151 !important; }
        .tq-dark-page .bg-gradient-to-r.from-gray-50 { background: #374151 !important; }
        .tq-dark-page .from-gray-50.to-blue-50 { background: linear-gradient(to right, #374151, #1e3a5f) !important; }
        .tq-dark-page .from-gray-50.to-gray-100 { background: linear-gradient(to right, #374151, #374151) !important; }
        .tq-dark-page .bg-blue-100 { background-color: #1e3a5f !important; }
        .tq-dark-page .placeholder-gray-500::placeholder { color: #6b7280 !important; }
        .tq-dark-page table { border-color: #4b5563 !important; }
        .tq-dark-page thead { background-color: #374151 !important; background: #374151 !important; }
        .tq-dark-page tbody tr:hover { background-color: #374151 !important; }
        .tq-dark-page .border-t { border-color: #4b5563 !important; }
        .tq-dark-page .border-b { border-color: #4b5563 !important; }
      `;
    } else {
      if (el) el.remove();
    }
  }, [isDarkMode]);

  // Fetch initial data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userCompanyId = user?.user?.company._id || user?.user?.company;
        const [referencesRes, transportersRes, employeesRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_BASE_URL}/references/all?userCompanyId=${userCompanyId}`),
          axios.get(`${process.env.REACT_APP_API_BASE_URL}/transporters/all?userCompanyId=${userCompanyId}`),
          axios.get(`${process.env.REACT_APP_API_BASE_URL}/employees/company2/${userCompanyId}`)
        ]);
        setReferences(referencesRes.data);
        setTransporters(transportersRes.data);
        setEmployees(employeesRes.data.employees);
      } catch (error) {
        toast.error('Error fetching data');
      }
    };
    fetchData();
  }, [user?.user?.company]);
  // Fetch tally items
  const fetchTallyItems = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/tally/items`,
        {
          params: {
            page,
            limit,
            search: filter,
            company: (user?.user?.company._id || user?.user?.company),
            requireParameter: true // Add this parameter
          }
        }
      );
      setFilteredItems(response.data.data);
      setTotal(response.data.total);
    } catch (error) {
      toast.error('Error fetching items');
    }
  };
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchTallyItems();
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [filter, page, limit, user?.token]);
  // Focus search input when modal opens
  useEffect(() => {
    if (modalVisible.open && inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 100);
    }
  }, [modalVisible.open]);
  useEffect(() => {
    if (focusTarget) {
      const inputElement = document.getElementById(focusTarget);
      if (inputElement) {
        setTimeout(() => {
          inputElement.focus();
          inputElement.select();
        }, 0);
      }
      setFocusTarget(null);
    }
  }, [focusTarget]);
  // Section and item management functions
  const handleSectionChange = (index, field, value) => {
    const newSections = [...form.sections];
    newSections[index][field] = value;
    if (field === 'items') {
      newSections[index].totalAmount = calculateSectionTotal(newSections[index]);
    }
    setForm({
      ...form,
      sections: newSections,
      totalAmount: calculateGrandTotal()
    });
  };
  const replicateSection = (sectionIndex) => {
    const newSections = [...form.sections];
    const sectionToReplicate = { ...newSections[sectionIndex] };
    const clonedItems = sectionToReplicate.items.map(item => ({...item}));
    const newSection = {
      ...sectionToReplicate,
      name: `${sectionToReplicate.name} (Copy)`,
      items: clonedItems
    };
    newSections.splice(sectionIndex + 1, 0, newSection);
    setForm({
      ...form,
      sections: newSections
    });
  };
  const copySection = (sectionIndex) => {
    const sectionCopy = JSON.parse(JSON.stringify(form.sections[sectionIndex]));
    setCopiedSection(sectionCopy);
    localStorage.setItem('tally_quotation_clipboard_section', JSON.stringify(sectionCopy));
    toast.success('Section copied');
  };
  const pasteSection = () => {
    if (!copiedSection) {
      toast.info('No section copied');
      return;
    }
    setForm(prev => ({
      ...prev,
      sections: [...prev.sections, JSON.parse(JSON.stringify(copiedSection))]
    }));
    toast.success('Section pasted');
  };
  const calculateCoverageArea = (item) => {
    if (!item || !item.parameter || item.parameter.calculationType !== 'pcsPerBox') {
        return { perPiece: 0, perBox: 0 };
    }
    const param = item.parameter;
    const coveragePerBox = param.coverageArea;
    const coveragePerPiece = param.coverageArea / param.piecesPerBox;
    return {
        perPiece: parseFloat(coveragePerPiece.toFixed(3)),
        perBox: parseFloat(coveragePerBox.toFixed(3)),
        unit: param.coverageAreaUnit
    };
  };
  const calculateCoverageForItem = (item, boxes = 0, pieces = 0) => {
    if (!item?.parameter || item.parameter.calculationType !== 'pcsPerBox') {
        return {
            perPiece: 0,
            perBox: 0,
            total: 0,
            unit: 'sqft'
        };
    }
    const param = item.parameter;
    const piecesPerBox = param.piecesPerBox || 1;
    const coveragePerBox = param.coverageArea || 0;
    const coveragePerPiece = coveragePerBox / piecesPerBox;
    // Calculate total coverage
    const boxCoverage = boxes * coveragePerBox;
    const pieceCoverage = pieces * coveragePerPiece;
    const totalCoverage = boxCoverage + pieceCoverage;
    return {
        perPiece: parseFloat(coveragePerPiece.toFixed(3)),
        perBox: parseFloat(coveragePerBox.toFixed(3)),
        total: parseFloat(totalCoverage.toFixed(2)),
        unit: param.coverageAreaUnit || 'sqft'
    };
  };
  const handleItemChange = (sectionIndex, itemIndex, field, value) => {
    setForm(prevForm => {
      const newForm = JSON.parse(JSON.stringify(prevForm));
      const item = newForm.sections[sectionIndex].items[itemIndex];
      if (['discount', 'listedPrice', 'quantity', 'boxes', 'pieces'].includes(field)) {
        const numValue = parseFloat(value) || 0;
        item[field] = numValue;
        const parameter = item.parameter;
        if (parameter?.calculationType === 'pcsPerBox') {
          const piecesPerBox = parameter.piecesPerBox || 1;
          if (field === 'boxes' || field === 'pieces') {
            item.quantity = (item.boxes * piecesPerBox) + item.pieces;
          }
          const boxPrice = parseFloat(item.listedPrice) || 0;
          const boxes = parseInt(item.boxes) || 0;
          const pieces = parseInt(item.pieces) || 0;
          const discount = parseFloat(item.discount) || 0;
          const equivalentBoxes = (pieces / piecesPerBox) + boxes;
          item.listedPriceTotal = equivalentBoxes * boxPrice;
          const discountMultiplier = 1 - (discount / 100);
          item.offerPrice = boxPrice * discountMultiplier;
          item.offerPriceTotal = item.listedPriceTotal * discountMultiplier;
          if (field === 'boxes' || field === 'pieces') {
            // Fix: Make sure we're passing the parameter correctly
            const coverage = calculateCoverageForItem({
              parameter: parameter  // Use the parameter directly
            }, boxes, pieces);
            
            // Ensure the values are set properly
            item.coverageArea = coverage.total || 0;
            item.coverageAreaUnit = coverage.unit || 'sqft';
            
            // Debug log to verify calculations
            console.log('Coverage calculated:', {
              boxes, pieces, piecesPerBox, 
              coveragePerBox: parameter.coverageArea,
              coverageResult: coverage
            });
          }
        } else {
          const listPrice = parseFloat(item.listedPrice) || 0;
          const quantity = parseFloat(item.quantity) || 0;
          const discount = parseFloat(item.discount) || 0;
          item.listedPriceTotal = listPrice * quantity;
          item.offerPrice = listPrice * (1 - (discount / 100));
          item.offerPriceTotal = item.offerPrice * quantity;
        }
      } else {
        item[field] = value;
      }
      const section = newForm.sections[sectionIndex];
      section.listedPriceTotal = section.items.reduce(
        (total, item) => total + (parseFloat(item.listedPriceTotal) || 0),
        0
      );
      section.offerPriceTotal = section.items.reduce(
        (total, item) => total + (parseFloat(item.offerPriceTotal) || 0),
        0
      );
      return newForm;
    });
  };
  const moveSection = (fromIndex, direction) => {
    const toIndex = direction === 'up' ? fromIndex - 1 : fromIndex + 1;
    if (toIndex < 0 || toIndex >= form.sections.length) return;
    const newSections = [...form.sections];
    [newSections[fromIndex], newSections[toIndex]] = [newSections[toIndex], newSections[fromIndex]];
    setForm({
      ...form,
      sections: newSections
    });
  };
  const calculateSectionTotal = (section) => {
    return section.items.reduce((total, item) => total + Number(item.amount || 0), 0);
  };
  const calculateSectionOfferTotal = (section) => {
    return section.items.reduce((total, item) => total + (item.offerPriceTotal || 0), 0);
  };
  const calculateSectionShowroomTotal = (section) => {
    return section.items.reduce((total, item) => total + (item.showroomPriceTotal || 0), 0);
  };
  const calculateGrandTotal = useCallback((sections = form.sections) => {
    // Add null check for sections
    if (!sections) return 0;
    // Calculate sections total
    const sectionsTotal = sections.reduce((total, section) => 
      total + (section.totalAmount || 0), 0
    );
    // Get additional charges with null checks
    const cartage = parseFloat(form.cartage || 0);
    const packingAndForwarding = parseFloat(form.packingAndForwarding || 0);
    const labour = parseFloat(form.labour || 0);
    const roundOff = parseFloat(form.roundOff || 0);
    // Calculate total additional charges
    const additionalCharges = cartage + packingAndForwarding + labour;
    // Calculate GST on additional charges
    const GST_RATE = 0.18;
    const additionalChargesGST = additionalCharges * GST_RATE;
    // Calculate subtotal
    const subtotal = sectionsTotal + additionalCharges + additionalChargesGST;
    // Apply round off
    const total = subtotal + roundOff;
    return parseFloat(total.toFixed(2));
  }, [form.cartage, form.packingAndForwarding, form.labour, form.roundOff]);
  const calculateOfferGrandTotal = (sections) => {
    return sections.reduce((total, section) => total + (section.offerPriceTotal || 0), 0);
  };
  const calculateShowroomGrandTotal = (sections) => {
    return sections.reduce((total, section) => total + (section.showroomPriceTotal || 0), 0);
  };
  const calculateSectionListedTotal = (section) => {
    return section.items.reduce((total, item) => total + (item.listedPriceTotal || 0), 0);
  };
  const calculateListedGrandTotal = (sections) => {
    return sections.reduce((total, section) => total + (section.listedPriceTotal || 0), 0);
  };
  // Update the validate function
  const validate = () => {
    if (!form.recipient || !form.recipient.value || !form.recipientType) {
      Swal.fire({
        icon: 'error',
        title: 'Recipient Required',
        text: 'Please select a recipient for the quotation',
        confirmButtonColor: '#3085d6',
      });
      return false;
    }
    if (form.salesmen.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Salesmen Required',
        text: 'Please select at least one salesman',
        confirmButtonColor: '#3085d6',
      });
      return false;
    }
    if (form.sections.some(section => !section.name)) {
      Swal.fire({
        icon: 'error',
        title: 'Section Name Required',
        text: 'All sections must have a name',
        confirmButtonColor: '#3085d6',
      });
      return false;
    }
    // Modified validation for items with different calculation types
    const invalidItems = form.sections.find(section => 
      section.items.some(item => {
        if (!item.item) return true; // Item reference is required for all
        // For items with box/piece calculation
        if (item.parameter?.calculationType === 'pcsPerBox') {
          return (item.boxes <= 0 && item.pieces <= 0) || item.listedPrice <= 0;
        }
        // For regular items
        return !item.quantity || item.quantity <= 0 || item.listedPrice <= 0;
      })
    );
    if (invalidItems) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Items',
        text: 'All items must have a valid item selection, quantity, and price',
        confirmButtonColor: '#3085d6',
      });
      return false;
    }
    return true;
  };
  // Update the handleSubmit function to map quantity correctly for all item types
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      // Show loading
      Swal.fire({
        title: 'Processing...',
        text: 'Please wait while we save your quotation',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      const formData = {
        ...form,
        recipient: form.recipient?.value || '',
        sections: form.sections.map(section => ({
          ...section,
          items: section.items.map(item => {
            // Base item data
            const formattedItem = {
              ...item,
              itemName: item.itemName || '',
              customName: item.customName || '',
              applicationArea: item.applicationArea || '',
              unit: item.unit || 'pcs',
              listedPrice: parseFloat(item.listedPrice) || 0,
              discount: parseFloat(item.discount) || 0,
              offerPrice: parseFloat(item.offerPrice) || 0,
              offerPriceTotal: parseFloat(item.offerPriceTotal) || 0,
              coverageArea: parseFloat(item.coverageArea) || 0,
              coverageAreaUnit: item.coverageAreaUnit || 'sqft'
            };
            // Handle box/piece calculation items differently
            if (item.parameter?.calculationType === 'pcsPerBox') {
              formattedItem.boxes = parseFloat(item.boxes) || 0;
              formattedItem.pieces = parseFloat(item.pieces) || 0;
            } else {
              formattedItem.boxes = 0;
              formattedItem.pieces = 0;
            }
            return formattedItem;
          })
        })),
        cartage: parseFloat(form.cartage) || 0,
        packingAndForwarding: parseFloat(form.packingAndForwarding) || 0,
        labour: parseFloat(form.labour) || 0,
        roundOff: parseFloat(form.roundOff) || 0,
        totalAmount: parseFloat(form.totalAmount) || 0
      };
      if (edit) {
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/tally-quotation/${editId}`, formData);
        await Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Quotation updated successfully',
          confirmButtonColor: '#3085d6',
        });
      } else {
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/tally-quotation`, formData);
        await Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Quotation created successfully',
          confirmButtonColor: '#3085d6',
        });
      }
      resetForm();
      fetchQuotations();
    } catch (error) {
      console.error('Error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: error.response?.data?.error || 'An error occurred while processing your request',
        confirmButtonColor: '#3085d6',
      });
    }
  };
  const resetForm = () => {
    setForm({
      recipient: null,
      recipientType: 'Customer',
      siteAddress: '', // Add this line
      salesmen: [],
      sections: [{
        name: '',
        items: [{
          item: '',
          itemName: '',
          customName: '',
          applicationArea: '',
          boxes: 1,
          pieces: 0,
          quantity: 1,
          unit: 'pcs',
          listedPrice: 0, // renamed from rate
          listedPriceTotal: 0,
          offerPrice: 0,
          offerPriceTotal: 0,
          discount: 0,
          coverageArea: 0,
          coverageAreaUnit: 'sqft'
        }],
        listedPriceTotal: 0,
        offerPriceTotal: 0,
      }],
      listedPriceGrandTotal: 0,
      offerPriceGrandTotal: 0,
      reference: null,
      referenceName: '',
      transporterName: null,
      transporterDisplayName: '',
      remarks: '',
      createdBy: user?.user?._id,
      createdAt: new Date().toISOString(),
      cartage: 0,
      packingAndForwarding: 0,
      labour: 0,
      roundOff: 0,
      totalAmount: 0
    });
    setEdit(false);
    setEditId(null);
  };
  const fetchQuotationStats = async () => {
    try {
      setStatsLoading(true);
      
      // Focus specifically on the logged-in user's company quotations
      const params = {
        companyId: user?.user?.company?._id || user?.user?.company,
        createdBy: user?.user?._id
      };
      
      // Add date range if present in filters
      if (advancedFilters.startDate) {
        const startDate = new Date(advancedFilters.startDate);
        startDate.setHours(0, 0, 0, 0);
        params.startDate = startDate.toISOString();
      }
      if (advancedFilters.endDate) {
        const endDate = new Date(advancedFilters.endDate);
        endDate.setHours(23, 59, 59, 999);
        params.endDate = endDate.toISOString();
      }
      
      console.log("Fetching quotation stats for user:", user.user._id);
      
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/tally-quotation/stats`,
        { params }
      );
      
      debugApiResponse(response, "Quotation Stats Response");
      if (response.data.success) {
        const stats = response.data.stats;
        const statusCounts = {
          completed: parseInt(stats.completedCount || 0),
          partial: parseInt(stats.partialCount || 0),
          pending: parseInt(stats.pendingCount || 0)
        };
        setQuoteStats({
          totalQuotations: parseInt(stats.totalQuotations || 0),
          totalAmount: formatNumberWithCommas(stats.totalAmount),
          avgAmount: formatNumberWithCommas(stats.avgAmount),
          minAmount: formatNumberWithCommas(stats.minAmount),
          maxAmount: formatNumberWithCommas(stats.maxAmount),
          customerCount: parseInt(stats.customerCount || 0),
          dealerCount: parseInt(stats.dealerCount || 0),
          customerAmount: formatNumberWithCommas(stats.customerAmount),
          dealerAmount: formatNumberWithCommas(stats.dealerAmount),
          statusCounts,
          monthlyTrends: (stats.monthlyTrends || []).map(trend => ({
            year: trend.year,
            month: trend.month,
            count: parseInt(trend.count || 0),
            amount: formatNumberWithCommas(trend.amount)
          }))
        });

        // Fallback: if backend doesn't include split counts, derive from list API.
        if (!stats.completedCount && !stats.partialCount && !stats.pendingCount) {
          const listResp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/tally-quotation/list`, {
            params: {
              page: 1,
              limit: 10000,
              createdBy: user?.user?._id
            }
          });
          const allQuotes = listResp?.data?.data || [];
          const completed = allQuotes.filter(q => q.status === 'COMPLETED').length;
          const partial = allQuotes.filter(q => q.status === 'PARTIAL-COMPLETE').length;
          const pending = allQuotes.filter(q => q.status === 'PENDING').length;
          setQuoteStats(prev => ({
            ...prev,
            statusCounts: { completed, partial, pending }
          }));
        }
      }
    } catch (error) {
      console.error('Error fetching statistics:', error);
      toast.error('Failed to fetch statistics');
    } finally {
      setStatsLoading(false);
    }
  };
  const fetchLastSevenDaysStats = async () => {
    try {
      setStatsLoading(true);
      // Calculate date range for the last 7 days
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 7);
      
      console.log("Fetching last 7 days stats for logged-in employee:", user.user._id);
      
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/tally-quotation/stats`,
        { 
          params: {
            userId: user.user._id,
            createdBy: user.user._id, // Filter by creator (logged-in user)
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
          }
        }
      );
      
      debugApiResponse(response, "Last 7 Days Stats Response");
      
      if (response.data.success) {
        const stats = response.data.stats;
        setLastSevenDaysStats({
          totalQuotations: parseInt(stats.totalQuotations || 0),
          totalAmount: formatNumberWithCommas(stats.totalAmount),
          avgAmount: formatNumberWithCommas(stats.avgAmount),
          customerCount: parseInt(stats.customerCount || 0),
          dealerCount: parseInt(stats.dealerCount || 0)
        });
      }
    } catch (error) {
      console.error('Error fetching last seven days statistics:', error);
      toast.error('Failed to fetch recent statistics');
    } finally {
      setStatsLoading(false);
    }
  };
  const handleFilterChange = (field, value) => {
    setAdvancedFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const applyFilters = () => {
    setQuotationPage(1);
    fetchQuotations(); // ensures new filters are applied
    fetchQuotationStats();
  };
  const resetAdvancedFilters = () => {
    setAdvancedFilters({
      recipientType: '',
      startDate: null,
      endDate: null,
      minAmount: '',
      maxAmount: '',
      salesmanId: ''
    });
    setSearchQuery('');
    setQuotationPage(1);
    fetchQuotations();
    fetchQuotationStats();
  };

  // Handle send tally quotation via WhatsApp
  const handleWhatsAppSend = async (quotation) => {
    try {
      const checkRes = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/whatsapp-automations/check-automation/tally-quotation-send`
      );
      
      if (!checkRes.data.data.isActive) {
        return Swal.fire('Not Enabled', 'Tally quotation send via WhatsApp is not enabled. Please ask your Company Head to enable it in WhatsApp Automations.', 'warning');
      }
      if (!checkRes.data.data.isConnected) {
        const reconnectResult = await Swal.fire({
          icon: 'warning',
          title: 'WhatsApp Not Connected',
          text: 'WhatsApp is not connected. Would you like to try reconnecting?',
          showCancelButton: true,
          confirmButtonText: 'Try Reconnect',
          confirmButtonColor: '#25D366',
          cancelButtonText: 'Cancel'
        });
        if (!reconnectResult.isConfirmed) return;

        Swal.fire({ title: 'Reconnecting...', text: 'Attempting to restore WhatsApp connection...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
        try {
          const reconnectRes = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/whatsapp-automations/try-reconnect`,
            {},
            { withCredentials: true, headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
          );
          if (!reconnectRes.data.success) {
            return Swal.fire('Reconnect Failed', reconnectRes.data.message || 'Could not reconnect WhatsApp.', 'error');
          }
          Swal.close();
        } catch (reconnectErr) {
          return Swal.fire('Reconnect Failed', reconnectErr.response?.data?.message || 'Could not reconnect WhatsApp. Please ask your Company Head to connect.', 'error');
        }
      }

      const recipientName = quotation.recipient?.name || quotation.recipient?.businessName || 'Unknown';
      const recipientPhone = quotation.recipient?.phone || '';

      const { value: formValues } = await Swal.fire({
        title: 'Send Tally Quotation via WhatsApp',
        html: `
          <div style="text-align: left; font-size: 14px;">
            <p style="margin-bottom: 12px;"><strong>Recipient:</strong> ${recipientName}</p>
            <p style="margin-bottom: 12px;"><strong>Quotation:</strong> ${quotation.id || ''}</p>
            <p style="margin-bottom: 12px;"><strong>Amount:</strong> ₹${quotation.totalAmount?.toLocaleString('en-IN') || '0'}</p>
            <label style="display: block; margin-bottom: 4px; font-weight: 600;">Phone Number:</label>
            <input id="swal-phone" class="swal2-input" placeholder="Enter phone number" value="${recipientPhone}" style="margin: 0 0 8px 0; width: 100%; box-sizing: border-box;">
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Send via WhatsApp',
        confirmButtonColor: '#25D366',
        cancelButtonText: 'Cancel',
        preConfirm: () => {
          const phone = document.getElementById('swal-phone').value.trim();
          if (!phone) {
            Swal.showValidationMessage('Phone number is required');
            return false;
          }
          return { phone };
        }
      });

      if (!formValues) return;

      Swal.fire({ title: 'Sending...', text: 'Generating PDF and queuing message...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/whatsapp-automations/send-tally-quotation`,
        {
          quotationId: quotation._id,
          phone: formValues.phone,
          recipientName,
          recipientType: quotation.recipientType,
          recipientId: quotation.recipient?._id
        }
      );

      if (response.data.success) {
        Swal.fire('Queued!', response.data.message, 'success');
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      console.error('WhatsApp send error:', error);
      Swal.fire('Error', error.response?.data?.message || error.message || 'Failed to send tally quotation', 'error');
    }
  };

  const handleViewQuotation = async (quotationId) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/tally-quotation/${quotationId}`
      );
      debugApiResponse(response, "Quotation Details Response");
      if (response.data) {
        // Store the fetched quotation data
        setSelectedQuotation(response.data);
        setShowDetailsModal(true);
      } else {
        toast.error('Failed to fetch quotation details');
      }
    } catch (error) {
      console.error('Error fetching quotation details:', error);
      toast.error('Error loading quotation');
    } finally {
      setLoading(false);
    }
  }
  const fetchQuotations = async () => {
    try {
      setLoading(true);
      
      // Create params object with all filters - focus specifically on logged-in employee's quotations
      const params = {
        page: quotationPage,
        limit: quotationLimit,
        search: searchQuery,
        createdBy: user.user._id // Filter by creator (logged-in user) instead of just userId
      };
      
      // Only add non-empty filters
      if (advancedFilters.recipientType) {
        params.recipientType = advancedFilters.recipientType;
      }
      
      if (advancedFilters.startDate) {
        params.startDate = advancedFilters.startDate.toISOString();
      }
      
      if (advancedFilters.endDate) {
        params.endDate = advancedFilters.endDate.toISOString();
      }
      
      if (advancedFilters.minAmount) {
        params.minAmount = advancedFilters.minAmount;
      }
      
      if (advancedFilters.maxAmount) {
        params.maxAmount = advancedFilters.maxAmount;
      }
      
      if (advancedFilters.salesmanId) {
        params.salesmanId = advancedFilters.salesmanId;
      }

      console.log("Applying filters:", params); // Debug log
      
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/tally-quotation/list`,
        { params }
      );

      debugApiResponse(response, "Quotation List Response");
      
      if (response.data && response.data.success) {
        setQuotations(response.data.data || []);
        setTotalQuotations(response.data.pagination?.total || 0);
      } else {
        setQuotations([]);
        setTotalQuotations(0);
        toast.error('Error in response format when fetching quotations');
      }
    } catch (error) {
      console.error('Error fetching quotations:', error);
      toast.error('Error fetching quotations');
      setQuotations([]);
      setTotalQuotations(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        setLoading(true);
        await Promise.all([
          fetchQuotations(),
          fetchQuotationStats(),
          fetchLastSevenDaysStats()
        ]);
      } catch (error) {
        console.error('Error fetching initial data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, [quotationPage, quotationLimit, debouncedSearch]);

  useEffect(() => {
    if (user?.user?.company) {
      // Load stats when component mounts if company is available
      fetchQuotationStats();
      fetchLastSevenDaysStats();
    }
  }, [user?.user?.company]);

  const formatNumberWithCommas = (number) => {
    const value = typeof number === 'string' ? parseFloat(number) : number;
    if (!value || isNaN(value)) {
      return "0.00";
    }
    return new Intl.NumberFormat('en-IN', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    }).format(value);
  };

  const addCommas = (value) => {
    if (typeof value === 'number') {
      return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return value;
  };

  const handleChargeChange = (field, value) => {
    setForm(prev => {
      const newForm = { ...prev };
      newForm[field] = parseFloat(value) || 0;

      // Calculate total with additional charges
      const additionalCharges = (
        (newForm.cartage || 0) + 
        (newForm.packingAndForwarding || 0) + 
        (newForm.labour || 0)
      );
      
      // Add GST to additional charges
      const additionalChargesWithGST = additionalCharges * 1.18;
      
      // Calculate final total
      newForm.totalAmount = (
        newForm.offerPriceGrandTotal + 
        additionalChargesWithGST + 
        (newForm.roundOff || 0)
      );

      return newForm;
    });
  };

  const handleApplicationAreaChange = (itemId, value) => {
    setFilteredItems(prev => prev.map(item => {
      if (item._id === itemId) {
        return {
          ...item,
          applicationArea: value.toUpperCase()
        };
      }
      return item;
    }));
  };

  // Auto-resize textarea function
  const autoResizeTextarea = (element) => {
    if (element) {
      element.style.height = 'auto';
      element.style.height = Math.min(element.scrollHeight, 150) + 'px'; // Max height of 150px
    }
  };

  // Add recipient selection handler
  const handleRecipientSelect = (recipient, recipientType) => {
    // Get the appropriate name based on recipient type
    const recipientName = recipientType === 'Customer' ? recipient.name : recipient.businessName;
    
    // Determine the site address based on recipient type and available addresses
    let siteAddress = '';
    if (recipientType === 'Customer') {
      // For customers, prefer delivery address, fallback to site address
      siteAddress = recipient.deliveryAddress || recipient.siteAddress || '';
    } else {
      // For dealers, use the address field
      siteAddress = recipient.address || '';
    }
    
    setForm(prev => ({
      ...prev,
      recipientType: recipientType,
      recipient: {
        value: recipient._id,
        label: recipientType === 'Customer' 
          ? `${recipient.name} (Ph: ${recipient.phone}${recipient.customerCode ? `, ID: ${recipient.customerCode}` : ''}${recipient.station?.name ? `, Station: ${recipient.station.name}` : ''})`
          : `${recipient.businessName} (Ph: ${recipient.phone}${recipient.id ? `, ID: ${recipient.id}` : ''})`
      },
      siteAddress: siteAddress
    }));
    
    setShowRecipientModal(false);
  };

  const handleEdit = async (quotationId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/tally-quotation/${quotationId}`
      );
      const fullQuotation = response.data;

      debugApiResponse(response, "Edit Quotation Response");

      // Format sections and items with proper calculations
      const formattedSections = fullQuotation.sections.map((section) => {
        const items = section.items.map((item) => {
          // Get base values
          const listPrice = parseFloat(item.listedPrice) || 0;
          const boxes = parseInt(item.boxes) || 0;
          const pieces = parseInt(item.pieces) || 0;
          const discount = parseFloat(item.discount) || 0;
          const parameter = item.item?.parameter;

          let quantity, listedPriceTotal, offerPrice, offerPriceTotal;

          // Handle box-based calculations
          if (parameter?.calculationType === 'pcsPerBox') {
            const piecesPerBox = parameter.piecesPerBox || 1;
            
            // Calculate total quantity from boxes and pieces
            quantity = (boxes * piecesPerBox) + pieces;
            
            // Calculate box and piece totals
            const equivalentBoxes = boxes + (pieces / piecesPerBox);
            listedPriceTotal = equivalentBoxes * listPrice;
            
            offerPrice = listPrice * (1 - (discount / 100));
            offerPriceTotal = listedPriceTotal * (1 - (discount / 100));

            // Explicitly preserve the parameter object with all needed properties
            const preservedParameter = {
              calculationType: parameter.calculationType,
              piecesPerBox: parameter.piecesPerBox,
              coverageArea: parameter.coverageArea,
              coverageAreaUnit: parameter.coverageAreaUnit
            };

            // Calculate coverage area with the preserved parameter
            const coverage = calculateCoverageForItem(
              { parameter: preservedParameter },
              boxes,
              pieces
            );

            return {
              item: item.item?._id || item.item,
              itemName: item.item?.Name || item.itemName,
              customName: item.customName || item.item?.Name || '',
              applicationArea: item.applicationArea || '',
              boxes: boxes,
              pieces: pieces,
              quantity: quantity,
              unit: item.unit || 'pcs',
              listedPrice: listPrice,
              listedPriceTotal: listedPriceTotal,
              offerPrice: offerPrice,
              offerPriceTotal: offerPriceTotal,
              discount: discount,
              parameter: preservedParameter, // Store the preserved parameter
              coverageArea: coverage?.total || item.coverageArea || 0,
              coverageAreaUnit: coverage?.unit || item.coverageAreaUnit || 'sqft'
            };
          } else {
            quantity = parseInt(item.quantity) || 0;
            listedPriceTotal = listPrice * quantity;
            offerPrice = listPrice * (1 - (discount / 100));
            offerPriceTotal = offerPrice * quantity;

            return {
              item: item.item?._id || item.item,
              itemName: item.item?.Name || item.itemName,
              customName: item.customName || item.item?.Name || '',
              applicationArea: item.applicationArea || '',
              quantity: quantity,
              unit: item.unit || 'pcs',
              listedPrice: listPrice,
              listedPriceTotal: listedPriceTotal,
              offerPrice: offerPrice,
              offerPriceTotal: offerPriceTotal,
              discount: discount,
              parameter: parameter,
              boxes: 0, // Explicitly set boxes to 0
              pieces: 0, // Explicitly set pieces to 0
              coverageArea: item.coverageArea || 0,
              coverageAreaUnit: item.coverageAreaUnit || 'sqft'
            };
          }
        });

        // Calculate section totals
        const sectionListedTotal = items.reduce((total, item) => total + (item.listedPriceTotal || 0), 0);
        const sectionOfferTotal = items.reduce((total, item) => total + (item.offerPriceTotal || 0), 0);

        return {
          name: section.name || '',
          items: items,
          listedPriceTotal: sectionListedTotal,
          offerPriceTotal: sectionOfferTotal
        };
      });

      // Calculate grand totals and set form state
      const listedPriceGrandTotal = formattedSections.reduce(
        (total, section) => total + section.listedPriceTotal, 
        0
      );
      const offerPriceGrandTotal = formattedSections.reduce(
        (total, section) => total + section.offerPriceTotal, 
        0
      );

      // Calculate total amount with additional charges
      const additionalCharges = (
        (form.cartage || 0) + 
        (form.packingAndForwarding || 0) + 
        (form.labour || 0)
      );
      const additionalChargesWithGST = additionalCharges * 1.18;
      const totalAmount = offerPriceGrandTotal + additionalChargesWithGST + (form.roundOff || 0);

      // Create proper recipient object for form
      let recipientObj = null;
      if (fullQuotation.recipient) {
        const recipientType = fullQuotation.recipientType || 'Customer';
        recipientObj = {
          value: fullQuotation.recipient._id,
          label: recipientType === 'Customer' 
            ? `${fullQuotation.recipient.name} (Ph: ${fullQuotation.recipient.phone}${fullQuotation.recipient.customerCode ? `, ID: ${fullQuotation.recipient.customerCode}` : ''}${fullQuotation.recipient.station?.name ? `, Station: ${fullQuotation.recipient.station.name}` : ''})`
            : `${fullQuotation.recipient.businessName} (Ph: ${fullQuotation.recipient.phone}${fullQuotation.recipient.id ? `, ID: ${fullQuotation.recipient.id}` : ''})`
        };
      }

      // Set form state with recalculated values
      setForm({
        ...fullQuotation,
        recipient: recipientObj,
        recipientType: fullQuotation.recipientType || 'Customer',
        siteAddress: fullQuotation.siteAddress || '', // Add this line
        salesmen: fullQuotation.salesmen?.map(s => s._id) || [],
        sections: formattedSections,
        reference: fullQuotation.reference?._id || null,
        referenceName: fullQuotation.reference?.name || '',
        transporterName: fullQuotation.transporterName?._id || null,
        transporterDisplayName: fullQuotation.transporterName?.name || '',
        remarks: fullQuotation.remarks || '',
        cartage: parseFloat(fullQuotation.cartage) || 0,
        packingAndForwarding: parseFloat(fullQuotation.packingAndForwarding) || 0,
        labour: parseFloat(fullQuotation.labour) || 0,
        roundOff: parseFloat(fullQuotation.roundOff) || 0,
        listedPriceGrandTotal: listedPriceGrandTotal,
        offerPriceGrandTotal: offerPriceGrandTotal,
        totalAmount: calculateGrandTotal(formattedSections)
      });

      setEdit(true);
      setEditId(quotationId);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      console.error('Error loading quotation:', error);
      toast.error('Error loading quotation details');
    }
  };

  useEffect(() => {
    // Skip initial render and empty sections
    if (!form?.sections?.length) return;

    const calculateTotals = () => {
      const newSections = form.sections.map(section => {
        // Calculate item totals
        const items = section.items.map(item => {
          const listPrice = parseFloat(item.listedPrice) || 0;
          const boxes = parseInt(item.boxes) || 0;
          const pieces = parseInt(item.pieces) || 0;
          const discount = parseFloat(item.discount) || 0;

          if (item.parameter?.calculationType === 'pcsPerBox') {
            const piecesPerBox = item.parameter.piecesPerBox || 1;
            
            // Calculate equivalent boxes as per formula: (pieces/piecesPerBox) + boxes
            const equivalentBoxes = (pieces / piecesPerBox) + boxes;
            
            // Calculate listed total using the formula
            const listedPriceTotal = equivalentBoxes * listPrice;
            
            return {
              ...item,
              quantity: (boxes * piecesPerBox) + pieces,
              listedPriceTotal: listedPriceTotal,
              offerPrice: listPrice * (1 - (discount / 100)),
              offerPriceTotal: listedPriceTotal * (1 - (discount / 100))
            };
          }

          return {
            ...item,
            listedPriceTotal: listPrice * item.quantity,
            offerPrice: listPrice * (1 - (discount / 100)),
            offerPriceTotal: (listPrice * item.quantity) * (1 - (discount / 100))
          };
        });

        // Calculate section totals
        const sectionListedTotal = items.reduce(
          (total, item) => total + (parseFloat(item.listedPriceTotal) || 0),
          0
        );
        const sectionOfferTotal = items.reduce(
          (total, item) => total + (parseFloat(item.offerPriceTotal) || 0),
          0
        );

        return {
          ...section,
          items,
          listedPriceTotal: sectionListedTotal,
          offerPriceTotal: sectionOfferTotal
        };
      });

      // Calculate grand totals
      const listedPriceGrandTotal = newSections.reduce(
        (total, section) => total + section.listedPriceTotal,
        0
      );
      const offerPriceGrandTotal = newSections.reduce(
        (total, section) => total + section.offerPriceTotal,
        0
      );

      // Calculate total amount with additional charges
      const additionalCharges = (
        (form.cartage || 0) + 
        (form.packingAndForwarding || 0) + 
        (form.labour || 0)
      );
      const additionalChargesWithGST = additionalCharges * 1.18;
      const totalAmount = offerPriceGrandTotal + additionalChargesWithGST + (form.roundOff || 0);

      // Update form only if values have changed
      if (
        JSON.stringify(newSections) !== JSON.stringify(form.sections) ||
        listedPriceGrandTotal !== form.listedPriceGrandTotal ||
        offerPriceGrandTotal !== form.offerPriceGrandTotal ||
        totalAmount !== form.totalAmount
      ) {
        setForm(prev => ({
          ...prev,
          sections: newSections,
          listedPriceGrandTotal,
          offerPriceGrandTotal,
          totalAmount
        }));
      }
    };

    calculateTotals();
  }, [
    form.sections,
    form.cartage,
    form.packingAndForwarding,
    form.labour,
    form.roundOff
  ]);

  // Auto-resize textareas when form sections change
  useEffect(() => {
    const timer = setTimeout(() => {
      // Auto-resize all textareas for print name and application area
      form.sections.forEach((section, sectionIndex) => {
        section.items.forEach((item, itemIndex) => {
          const printNameTextarea = document.getElementById(`printName-${sectionIndex}-${itemIndex}`);
          if (printNameTextarea) {
            autoResizeTextarea(printNameTextarea);
          }
          
          const appAreaTextarea = document.getElementById(`appArea-${sectionIndex}-${itemIndex}`);
          if (appAreaTextarea) {
            autoResizeTextarea(appAreaTextarea);
          }
        });
      });
    }, 100);

    return () => clearTimeout(timer);
  }, [form.sections]);

  const addSection = () => {
    setForm({
      ...form,
      sections: [
        ...form.sections,
        {
          name: '',
          items: [{
            item: '',
            itemName: '',
            customName: '',
            applicationArea: '',
            boxes: 1,
            pieces: 0,
            quantity: 1,
            unit: 'pcs',
            listedPrice: 0, // renamed from rate
            listedPriceTotal: 0,
            offerPrice: 0,
            offerPriceTotal: 0,
            discount: 0,
            coverageArea: 0,
            coverageAreaUnit: 'sqft'
          }],
          listedPriceTotal: 0,
          offerPriceTotal: 0,
        }
      ]
    });
  };

  const deleteSection = async (index) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    });
    if (result.isConfirmed) {
      const newSections = form.sections.filter((_, i) => i !== index);
      setForm({
        ...form,
        sections: newSections,
        totalAmount: calculateGrandTotal(newSections)
      });
      Swal.fire(
        'Deleted!',
        'Section has been deleted.',
        'success'
      );
    }
  };

  const addItem = (sectionIndex) => {
    const newSections = [...form.sections];
    const itemIndex = newSections[sectionIndex].items.length;
    newSections[sectionIndex].items.push({
      item: '',
      itemName: '', // Make sure this is included
      customName: '',
      applicationArea: '',
      boxes: 1,
      pieces: 0,
      quantity: 1,
      unit: 'pcs',
      listedPrice: 0, // renamed from rate
      listedPriceTotal: 0,
      offerPrice: 0,
      offerPriceTotal: 0,
      discount: 0,
      coverageArea: 0,
      coverageAreaUnit: 'sqft'
    });
    setForm({
      ...form,
      sections: newSections
    });
    setTimeout(() => {
      openItemModal(sectionIndex, itemIndex);
    }, 0);
  };

  const deleteItem = async (sectionIndex, itemIndex) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    });
    if (result.isConfirmed) {
      const newSections = [...form.sections];
      newSections[sectionIndex].items = newSections[sectionIndex].items.filter((_, i) => i !== itemIndex);
      if (newSections[sectionIndex].items.length === 0) {
        deleteSection(sectionIndex);
      } else {
        newSections[sectionIndex].totalAmount = calculateSectionTotal(newSections[sectionIndex]);
        setForm({
          ...form,
          sections: newSections,
          totalAmount: calculateGrandTotal(newSections)
        });
        Swal.fire(
          'Deleted!',
          'Item has been deleted.',
          'success'
        );
      }
    }
  };

  const openItemModal = (sectionIndex, itemIndex) => {
    // Reset search and pagination
    setFilter('');
    setPage(1);
    
    setModalVisible({
      open: true,
      func: (selectedItem) => {
        const newSections = [...form.sections];
        const item = newSections[sectionIndex].items[itemIndex];
        
        // Update item with selected item details
        item.item = selectedItem._id;
        item.itemName = selectedItem.Name;
        item.customName = selectedItem.Name;
        item.parameter = selectedItem.parameter;
        item.reorderStatus = selectedItem.reorderStatus;
        item.closingBalance = selectedItem.closingBalance;
        item.baseUnits = selectedItem.baseUnits;
        item.additionalUnits = selectedItem.additionalUnits;
        
        // Set initial quantities based on calculation type
        if (selectedItem.parameter?.calculationType === 'pcsPerBox') {
          item.boxes = 1;
          item.pieces = 0;
          item.quantity = selectedItem.parameter.piecesPerBox || 1;
          const coverage = calculateCoverageForItem(selectedItem, item.boxes, item.pieces);
          item.coverageArea = coverage.total;
          item.coverageAreaUnit = coverage.unit;
        } else {
          item.boxes = 0;
          item.pieces = 0;
          item.quantity = 1; // Set default quantity for regular items
        }
        
        setForm({
          ...form,
          sections: newSections
        });
        setFocusTarget(`printName-${sectionIndex}-${itemIndex}`);
      }
    });
  };

  const handleViewItemDetails = (item) => {
    setSelectedItemForDetails(item);
    setShowItemDetailsModal(true);
  };

  const moveItem = (sectionIndex, itemIndex, direction) => {
    const newSections = [...form.sections];
    const items = newSections[sectionIndex].items;
    const toIndex = direction === 'up' ? itemIndex - 1 : itemIndex + 1;
  
    if (toIndex < 0 || toIndex >= items.length) return;
  
    // Swap items
    [items[itemIndex], items[toIndex]] = [items[toIndex], items[itemIndex]];
  
    setForm({
      ...form,
      sections: newSections
    });
  };
  const copyItem = (sectionIndex, itemIndex) => {
    const itemCopy = JSON.parse(JSON.stringify(form.sections[sectionIndex].items[itemIndex]));
    setCopiedItem(itemCopy);
    localStorage.setItem('tally_quotation_clipboard_item', JSON.stringify(itemCopy));
    toast.success('Item copied');
  };
  const pasteItem = (sectionIndex) => {
    if (!copiedItem) {
      toast.info('No item copied');
      return;
    }
    setForm(prev => {
      const newForm = JSON.parse(JSON.stringify(prev));
      newForm.sections[sectionIndex].items.push(JSON.parse(JSON.stringify(copiedItem)));
      return newForm;
    });
    toast.success('Item pasted');
  };

  // Choice import functions
  const loadChoices = async (page = 1, search = '') => {
    setLoadingChoices(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/tally-quotation/choices/list`, {
        params: {
          page,
          limit: 10,
          search: search.toUpperCase(),
          company: user?.user?.company?._id || user?.user?.company
        },
        headers: {
          'Authorization': `Bearer ${user.token}`
        }
      });
      
      if (response.data.success) {
        if (page === 1) {
          setChoices(response.data.data || []);
        } else {
          setChoices(prev => [...prev, ...(response.data.data || [])]);
        }
        setTotalChoicePages(response.data.pagination?.pages || 1);
      }
    } catch (error) {
      console.error('Error loading choices:', error);
      toast.error('Failed to load choices');
    } finally {
      setLoadingChoices(false);
    }
  };

  const handleChoiceSelect = (choice) => {
    setSelectedChoices(prev => {
      const isSelected = prev.some(c => c._id === choice._id);
      if (isSelected) {
        return prev.filter(c => c._id !== choice._id);
      } else {
        return [...prev, choice];
      }
    });
  };

  const importChoicesAsSection = async () => {
    if (selectedChoices.length === 0) {
      toast.error('Please select at least one choice to import');
      return;
    }

    if (!importingSectionName.trim()) {
      toast.error('Please enter a section name');
      return;
    }

    try {
      setLoadingChoices(true);
      
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/tally-quotation/import-from-choices`,
        {
          choiceIds: selectedChoices.map(c => c._id),
          sectionName: importingSectionName.trim()
        },
        {
          headers: {
            'Authorization': `Bearer ${user.token}`
          }
        }
      );

      if (response.data.success) {
        const { section, choiceReferences, summary } = response.data.data;
        
        // Add the imported section to the form
        setForm(prev => ({
          ...prev,
          sections: [...prev.sections, section]
        }));

        // Show success message with summary
        toast.success(
          `Successfully imported ${summary.totalItems} items from ${summary.totalChoices} choices`
        );

        // Reset and close modal
        setSelectedChoices([]);
        setImportingSectionName('');
        setShowChoiceImportModal(false);
        
      } else {
        toast.error(response.data.error || 'Failed to import choices');
      }
    } catch (error) {
      console.error('Error importing choices:', error);
      toast.error('Failed to import choices');
    } finally {
      setLoadingChoices(false);
    }
  };

  const openChoiceImportModal = () => {
    setShowChoiceImportModal(true);
    setSelectedChoices([]);
    setChoiceSearch('');
    setChoicePage(1);
    setImportingSectionName('Imported from Choices');
    loadChoices(1, '');
  };

  // Excel Export functionality
  const exportAllQuotationsToExcel = async () => {
    try {
      setLoading(true);
      
      // Fetch all quotations for export (without pagination)
      const params = {
        page: 1,
        limit: 10000, // Large limit to get all quotations
        search: searchQuery,
        createdBy: user.user._id
      };
      
      // Add filters if they exist
      if (advancedFilters.recipientType) params.recipientType = advancedFilters.recipientType;
      if (advancedFilters.startDate) params.startDate = advancedFilters.startDate.toISOString();
      if (advancedFilters.endDate) params.endDate = advancedFilters.endDate.toISOString();
      if (advancedFilters.minAmount) params.minAmount = advancedFilters.minAmount;
      if (advancedFilters.maxAmount) params.maxAmount = advancedFilters.maxAmount;
      if (advancedFilters.salesmanId) params.salesmanId = advancedFilters.salesmanId;
      
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/tally-quotation/list`,
        { params }
      );
      
      if (response.data.success && response.data.data.length > 0) {
        const ExcelJS = require('exceljs');
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Tally Quotations');
        
        // Define columns with headers and widths
        const columns = [
          { header: 'Quotation ID', key: 'id', width: 14 },
          { header: 'Status', key: 'status', width: 18 },
          { header: 'Recipient Name', key: 'recipientName', width: 28 },
          { header: 'Recipient Type', key: 'recipientType', width: 14 },
          { header: 'Sales Team', key: 'salesTeam', width: 24 },
          { header: 'Total Amount', key: 'totalAmount', width: 16 },
          { header: 'Reminder Status', key: 'reminderStatus', width: 22 },
          { header: 'Created Date', key: 'createdDate', width: 14 },
          { header: 'Site Address', key: 'siteAddress', width: 30 },
          { header: 'Reference', key: 'reference', width: 18 },
          { header: 'Transporter', key: 'transporter', width: 18 },
          { header: 'Remarks', key: 'remarks', width: 30 }
        ];
        worksheet.columns = columns;
        
        // Style header row
        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 };
        headerRow.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF4338CA' }
        };
        headerRow.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        headerRow.height = 28;
        headerRow.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin', color: { argb: 'FF312E81' } },
            bottom: { style: 'thin', color: { argb: 'FF312E81' } },
            left: { style: 'thin', color: { argb: 'FF312E81' } },
            right: { style: 'thin', color: { argb: 'FF312E81' } }
          };
        });
        
        // Add data rows
        for (const quotation of response.data.data) {
          let reminderStatus = 'No Reminders';
          try {
            const statusResponse = await axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/tally-quotation/status/${quotation._id}`
            );
            if (statusResponse.data.success) {
              const stats = statusResponse.data.statistics.reminderStats;
              reminderStatus = `${stats.completed}/${stats.total} Completed`;
              if (stats.partialComplete > 0) {
                reminderStatus += `, ${stats.partialComplete} Partial`;
              }
              if (stats.pending > 0) {
                reminderStatus += `, ${stats.pending} Pending`;
              }
            }
          } catch (error) {
            console.log('Could not fetch reminder status for quotation:', quotation._id);
          }
          
          const row = worksheet.addRow({
            id: quotation.id || '',
            status: quotation.status || 'PENDING',
            recipientName: quotation.recipientType === 'Customer' 
              ? quotation.recipient?.name || '' 
              : quotation.recipient?.businessName || '',
            recipientType: quotation.recipientType || '',
            salesTeam: quotation.salesmen?.map(s => s.name).join(', ') || '',
            totalAmount: quotation.totalAmount || 0,
            reminderStatus,
            createdDate: quotation.createdAt ? (() => { const d = new Date(quotation.createdAt); return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`; })() : '',
            siteAddress: quotation.siteAddress || '',
            reference: quotation.reference?.name || '',
            transporter: quotation.transporterName?.name || '',
            remarks: quotation.remarks || ''
          });
          
          // Alternate row colors
          const rowIndex = row.number;
          const bgColor = rowIndex % 2 === 0 ? 'FFF3F4F6' : 'FFFFFFFF';
          row.eachCell((cell) => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: bgColor } };
            cell.border = {
              bottom: { style: 'thin', color: { argb: 'FFE5E7EB' } },
              left: { style: 'thin', color: { argb: 'FFE5E7EB' } },
              right: { style: 'thin', color: { argb: 'FFE5E7EB' } }
            };
            cell.alignment = { vertical: 'middle', wrapText: true };
          });
          
          // Format amount as number
          row.getCell('totalAmount').numFmt = '#,##0.00';
          row.getCell('totalAmount').alignment = { vertical: 'middle', horizontal: 'right' };
          
          // Status color coding
          const statusCell = row.getCell('status');
          const statusColors = {
            'COMPLETED': 'FF059669', 'PARTIAL-COMPLETE': 'FFD97706', 'PENDING': 'FF2563EB',
            'CANCELLED': 'FFDC2626', 'REJECTED': 'FF6B7280', 'REFFOLLOW': 'FF7C3AED'
          };
          statusCell.font = { bold: true, color: { argb: statusColors[quotation.status] || 'FF6B7280' } };
        }
        
        // Auto-size columns based on content (min: header width, max: 50)
        worksheet.columns.forEach((column) => {
          let maxLen = column.header ? column.header.length : 10;
          column.eachCell({ includeEmpty: false }, (cell) => {
            const cellLen = cell.value ? String(cell.value).length : 0;
            if (cellLen > maxLen) maxLen = cellLen;
          });
          column.width = Math.min(Math.max(maxLen + 2, column.width || 12), 50);
        });
        
        // Generate filename with current date
        const currentDate = new Date().toISOString().slice(0, 10);
        const filename = `TallyQuotations_${currentDate}.xlsx`;
        
        // Save file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
        
        toast.success(`Excel file "${filename}" downloaded successfully!`);
      } else {
        toast.warning('No quotations found to export');
      }
    } catch (error) {
      console.error('Export error:', error);
      toast.error('Failed to export quotations to Excel');
    } finally {
      setLoading(false);
    }
  };

  // Export a single quotation to Excel with item images
  const exportSingleQuotationToExcel = async (quotation) => {
    try {
      setLoading(true);
      
      // Always fetch full quotation to ensure nested item parameters are populated (needed for pcsPerBox quantities)
      let fullQuotation = quotation;
      const needsFetch = !quotation.sections || !quotation.sections.length ||
        !quotation.sections[0]?.items?.[0]?.parameter?.calculationType &&
        !quotation.sections[0]?.items?.[0]?.item?.parameter?.calculationType;
      if (needsFetch) {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/tally-quotation/${quotation._id}`
        );
        if (!response.data) {
          toast.error('Failed to fetch quotation details');
          return;
        }
        fullQuotation = response.data;
      }

      const ExcelJS = require('exceljs');
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Quotation');

      // Styling constants
      const headerFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4338CA' } };
      const sectionFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF6366F1' } };
      const subHeaderFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF3F4F6' } };
      const whiteFont = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 };
      const thinBorder = {
        top: { style: 'thin', color: { argb: 'FFE5E7EB' } },
        bottom: { style: 'thin', color: { argb: 'FFE5E7EB' } },
        left: { style: 'thin', color: { argb: 'FFE5E7EB' } },
        right: { style: 'thin', color: { argb: 'FFE5E7EB' } }
      };

      // Set column widths: A=Image, B=Item Name, C=App Area, D=Qty, E=Listed Price, F=Discount, G=Offer Total
      worksheet.columns = [
        { width: 16 }, // A - Image
        { width: 32 }, // B - Item Name
        { width: 22 }, // C - Application Area
        { width: 16 }, // D - Quantity
        { width: 16 }, // E - Listed Price
        { width: 12 }, // F - Discount %
        { width: 18 }, // G - Offer Total
      ];

      let currentRow = 1;

      // Title row
      const recipientName = fullQuotation.recipientType === 'Customer'
        ? fullQuotation.recipient?.name
        : fullQuotation.recipient?.businessName;
      worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
      const titleCell = worksheet.getCell(`A${currentRow}`);
      titleCell.value = `Tally Quotation - ${fullQuotation.id || ''}`;
      titleCell.font = { bold: true, size: 14, color: { argb: 'FFFFFFFF' } };
      titleCell.fill = headerFill;
      titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
      worksheet.getRow(currentRow).height = 32;
      currentRow++;

      // Info rows
      const infoData = [
        ['Recipient', `${recipientName || 'N/A'} (${fullQuotation.recipientType || ''})`],
        ['Status', fullQuotation.status || 'PENDING'],
        ['Date', fullQuotation.createdAt ? new Date(fullQuotation.createdAt).toLocaleDateString('en-IN') : 'N/A'],
        ['Sales Team', fullQuotation.salesmen?.map(s => s.name).join(', ') || 'N/A'],
        ['Reference', fullQuotation.reference?.name || 'N/A'],
        ['Transporter', fullQuotation.transporterName?.name || 'N/A'],
        ['Site Address', fullQuotation.siteAddress || 'N/A'],
      ];
      
      for (const [label, value] of infoData) {
        worksheet.mergeCells(`B${currentRow}:G${currentRow}`);
        const labelCell = worksheet.getCell(`A${currentRow}`);
        labelCell.value = label;
        labelCell.font = { bold: true, size: 10, color: { argb: 'FF4B5563' } };
        labelCell.fill = subHeaderFill;
        labelCell.border = thinBorder;
        const valCell = worksheet.getCell(`B${currentRow}`);
        valCell.value = value;
        valCell.font = { size: 10 };
        valCell.fill = subHeaderFill;
        valCell.border = thinBorder;
        currentRow++;
      }
      currentRow++; // blank row

      // Fetch images for all items in parallel
      const imageCache = {};
      const imagePromises = [];
      for (const section of fullQuotation.sections) {
        for (const item of section.items) {
          const itemId = item.item?._id || item.item;
          if (itemId && !imageCache[itemId]) {
            imagePromises.push(
              axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/tally/items/${itemId}/image`,
                { responseType: 'arraybuffer', timeout: 8000 }
              ).then(res => {
                const contentType = res.headers['content-type'] || 'image/jpeg';
                const ext = contentType.includes('png') ? 'png' : 'jpeg';
                imageCache[itemId] = { buffer: res.data, extension: ext };
              }).catch(() => {
                // No image available for this item
              })
            );
          }
        }
      }
      await Promise.all(imagePromises);

      // Sections with items
      for (const [sectionIndex, section] of fullQuotation.sections.entries()) {
        // Section header row
        worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
        const sectionCell = worksheet.getCell(`A${currentRow}`);
        sectionCell.value = `Section ${sectionIndex + 1}: ${section.name || 'Untitled'}`;
        sectionCell.font = whiteFont;
        sectionCell.fill = sectionFill;
        sectionCell.alignment = { horizontal: 'left', vertical: 'middle' };
        worksheet.getRow(currentRow).height = 26;
        currentRow++;

        // Column headers
        const colHeaders = ['Image', 'Item Name', 'Application Area', 'Quantity', 'Listed Price', 'Discount %', 'Offer Total'];
        const headerRow = worksheet.getRow(currentRow);
        colHeaders.forEach((header, i) => {
          const cell = headerRow.getCell(i + 1);
          cell.value = header;
          cell.font = { bold: true, size: 10, color: { argb: 'FF374151' } };
          cell.fill = subHeaderFill;
          cell.border = thinBorder;
          cell.alignment = { horizontal: i >= 4 ? 'right' : 'left', vertical: 'middle' };
        });
        headerRow.height = 22;
        currentRow++;

        // Item rows
        for (const item of section.items) {
          const itemId = item.item?._id || item.item;
          const hasImage = itemId && imageCache[itemId];
          const rowHeight = hasImage ? 60 : 22;

          const dataRow = worksheet.getRow(currentRow);
          dataRow.height = rowHeight;

          // A - Image
          if (hasImage) {
            try {
              const imgData = imageCache[itemId];
              const imageId = workbook.addImage({
                buffer: imgData.buffer,
                extension: imgData.extension,
              });
              worksheet.addImage(imageId, {
                tl: { col: 0, row: currentRow - 1 },
                ext: { width: 80, height: 60 },
              });
            } catch (e) {
              dataRow.getCell(1).value = '(image error)';
            }
          } else {
            dataRow.getCell(1).value = '-';
          }

          // B - Item Name
          const nameCell = dataRow.getCell(2);
          nameCell.value = item.customName || item.itemName || item.item?.Name || '';
          nameCell.font = { size: 10 };
          nameCell.alignment = { wrapText: true, vertical: 'middle' };

          // C - Application Area
          dataRow.getCell(3).value = item.applicationArea || '-';
          dataRow.getCell(3).alignment = { vertical: 'middle' };

          // D - Quantity
          let qtyText;
          if (item.parameter?.calculationType === 'pcsPerBox' || item.item?.parameter?.calculationType === 'pcsPerBox') {
            qtyText = `${item.boxes || 0} Box, ${item.pieces || 0} Pcs`;
            if (item.coverageArea > 0) qtyText += ` (${item.coverageArea} ${item.coverageAreaUnit || 'sqft'})`;
          } else {
            qtyText = `${item.quantity || 0} ${(item.unit || 'pcs').toUpperCase()}`;
          }
          dataRow.getCell(4).value = qtyText;
          dataRow.getCell(4).alignment = { vertical: 'middle' };

          // E - Listed Price
          dataRow.getCell(5).value = item.listedPrice || 0;
          dataRow.getCell(5).numFmt = '₹#,##0.00';
          dataRow.getCell(5).alignment = { horizontal: 'right', vertical: 'middle' };

          // F - Discount %
          dataRow.getCell(6).value = item.discount ? `${item.discount}%` : '-';
          dataRow.getCell(6).alignment = { horizontal: 'right', vertical: 'middle' };

          // G - Offer Total
          dataRow.getCell(7).value = item.offerPriceTotal || 0;
          dataRow.getCell(7).numFmt = '₹#,##0.00';
          dataRow.getCell(7).font = { bold: true, size: 10 };
          dataRow.getCell(7).alignment = { horizontal: 'right', vertical: 'middle' };

          // Apply borders
          for (let c = 1; c <= 7; c++) {
            dataRow.getCell(c).border = thinBorder;
          }

          const rowIdx = dataRow.number;
          const bgColor = rowIdx % 2 === 0 ? 'FFF3F4F6' : 'FFFFFFFF';
          for (let c = 1; c <= 7; c++) {
            dataRow.getCell(c).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: bgColor } };
          }

          currentRow++;
        }

        // Section subtotal row
        const subtotalRow = worksheet.getRow(currentRow);
        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
        subtotalRow.getCell(1).value = `Section Total: ${section.name || ''}`;
        subtotalRow.getCell(1).font = { bold: true, size: 10 };
        subtotalRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle' };
        subtotalRow.getCell(7).value = section.offerPriceTotal || 0;
        subtotalRow.getCell(7).numFmt = '₹#,##0.00';
        subtotalRow.getCell(7).font = { bold: true, size: 10, color: { argb: 'FF059669' } };
        subtotalRow.getCell(7).alignment = { horizontal: 'right', vertical: 'middle' };
        for (let c = 1; c <= 7; c++) {
          subtotalRow.getCell(c).border = thinBorder;
          subtotalRow.getCell(c).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFDBEAFE' } };
        }
        currentRow += 2; // gap between sections
      }

      // Additional charges
      worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
      const chargesHeader = worksheet.getCell(`A${currentRow}`);
      chargesHeader.value = 'Additional Charges';
      chargesHeader.font = { bold: true, size: 11, color: { argb: 'FF374151' } };
      chargesHeader.fill = subHeaderFill;
      chargesHeader.border = thinBorder;
      currentRow++;

      const charges = [
        ['Cartage', fullQuotation.cartage || 0],
        ['Packing & Forwarding', fullQuotation.packingAndForwarding || 0],
        ['Labour', fullQuotation.labour || 0],
        ['Round Off', fullQuotation.roundOff || 0],
      ];

      for (const [label, amount] of charges) {
        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
        const labelCell = worksheet.getCell(`A${currentRow}`);
        labelCell.value = label;
        labelCell.font = { size: 10 };
        labelCell.alignment = { horizontal: 'right', vertical: 'middle' };
        labelCell.border = thinBorder;
        const amtCell = worksheet.getCell(`G${currentRow}`);
        amtCell.value = amount;
        amtCell.numFmt = '₹#,##0.00';
        amtCell.alignment = { horizontal: 'right', vertical: 'middle' };
        amtCell.border = thinBorder;
        currentRow++;
      }

      // Grand total
      currentRow++;
      worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
      const gtLabel = worksheet.getCell(`A${currentRow}`);
      gtLabel.value = 'GRAND TOTAL';
      gtLabel.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
      gtLabel.fill = headerFill;
      gtLabel.alignment = { horizontal: 'right', vertical: 'middle' };
      const gtVal = worksheet.getCell(`G${currentRow}`);
      gtVal.value = fullQuotation.totalAmount || 0;
      gtVal.numFmt = '₹#,##0.00';
      gtVal.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
      gtVal.fill = headerFill;
      gtVal.alignment = { horizontal: 'right', vertical: 'middle' };
      worksheet.getRow(currentRow).height = 28;

      // Remarks
      if (fullQuotation.remarks) {
        currentRow += 2;
        worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
        const remarkCell = worksheet.getCell(`A${currentRow}`);
        remarkCell.value = `Remarks: ${fullQuotation.remarks}`;
        remarkCell.font = { italic: true, size: 10, color: { argb: 'FF92400E' } };
        remarkCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFBEB' } };
        remarkCell.alignment = { wrapText: true, vertical: 'middle' };
      }

      // Download
      const qId = fullQuotation.id || fullQuotation._id;
      const filename = `Quotation_${qId}_${new Date().toISOString().slice(0, 10)}.xlsx`;
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(url);

      toast.success(`Quotation exported: ${filename}`);
    } catch (error) {
      console.error('Export single quotation error:', error);
      toast.error('Failed to export quotation');
    } finally {
      setLoading(false);
    }
  };

  // Function to get reminder status for a quotation
  const [quotationStatuses, setQuotationStatuses] = useState({});
  
  const fetchQuotationStatus = async (quotationId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/tally-quotation/status/${quotationId}`
      );
      if (response.data.success) {
        return response.data.statistics.reminderStats;
      }
    } catch (error) {
      console.log('Could not fetch reminder status for quotation:', quotationId);
    }
    return null;
  };

  // Load reminder statuses for visible quotations
  useEffect(() => {
    const loadStatuses = async () => {
      const newStatuses = {};
      for (const quotation of quotations) {
        const status = await fetchQuotationStatus(quotation._id);
        if (status) {
          newStatuses[quotation._id] = status;
        }
      }
      setQuotationStatuses(newStatuses);
    };
    
    if (quotations.length > 0) {
      loadStatuses();
    }
  }, [quotations]);

  // Dark mode: conditional Tailwind class strings
  const dc = useMemo(() => ({
    page: isDarkMode
      ? 'p-6 w-full mx-auto min-h-screen bg-gray-900 text-gray-100'
      : 'p-6 w-full mx-auto min-h-screen bg-gradient-to-br from-gray-50 via-blue-50/30 to-indigo-50/20',
    headingText: isDarkMode ? 'text-3xl font-bold mb-6 text-gray-100' : 'text-3xl font-bold mb-6 text-gray-900',
    formCard: isDarkMode
      ? 'bg-gray-800 rounded-lg shadow-md p-6 mb-6 border border-gray-700'
      : 'bg-white rounded-lg shadow-md p-6 mb-6 border border-gray-200',
    sectionCard: isDarkMode
      ? 'bg-gray-800 rounded-lg shadow-md p-6 mb-6 border border-gray-700'
      : 'bg-white rounded-lg shadow-md p-6 mb-6 border border-gray-200',
    sectionHeader: isDarkMode
      ? 'flex justify-between items-center border-b border-gray-600 pb-4 mb-6'
      : 'flex justify-between items-center border-b border-gray-200 pb-4 mb-6',
    sectionNameInput: isDarkMode
      ? 'w-full px-4 py-2.5 rounded-lg border border-gray-600 bg-gray-700/70 text-lg font-semibold text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all'
      : 'w-full px-4 py-2.5 rounded-lg border border-gray-300 bg-white text-lg font-semibold text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all',
    tableBg: isDarkMode ? 'overflow-x-auto bg-gray-800' : 'overflow-x-auto bg-white',
    tableHead: isDarkMode ? 'bg-gray-700' : 'bg-gray-50',
    tableHeadTh: isDarkMode
      ? 'px-4 py-2 text-left text-xs font-medium text-gray-300 uppercase tracking-wider'
      : 'px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider',
    tableRow: isDarkMode ? 'bg-gray-800 hover:bg-gray-700 cursor-pointer transition-colors' : 'bg-white hover:bg-blue-50 cursor-pointer transition-colors',
    tableRowAlt: isDarkMode ? 'bg-gray-750 hover:bg-gray-700 cursor-pointer transition-colors' : 'bg-gray-50 hover:bg-blue-50 cursor-pointer transition-colors',
    tableTd: isDarkMode ? 'px-6 py-4 whitespace-nowrap text-sm text-gray-300' : 'px-6 py-4 whitespace-nowrap text-sm text-gray-600',
    tableTdBold: isDarkMode ? 'px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100' : 'px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900',
    itemBtn: isDarkMode ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-800',
    inputBase: isDarkMode
      ? 'w-full p-2 border rounded-md bg-gray-700 border-gray-600 text-gray-100 focus:ring-blue-500 focus:border-blue-500'
      : 'w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500',
    labelBase: isDarkMode ? 'block text-sm font-medium text-gray-300 mb-2' : 'block text-sm font-medium text-gray-700 mb-2',
    textPrimary: isDarkMode ? 'text-gray-100' : 'text-gray-900',
    textSecondary: isDarkMode ? 'text-gray-400' : 'text-gray-600',
    textMuted: isDarkMode ? 'text-gray-500' : 'text-gray-400',
    border: isDarkMode ? 'border-gray-700' : 'border-gray-200',
    sectionFooter: isDarkMode
      ? 'flex justify-between items-center mt-6 pt-4 border-t border-gray-600'
      : 'flex justify-between items-center mt-6 pt-4 border-t border-gray-200',
    addItemBtn: isDarkMode
      ? 'bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-500 flex items-center gap-2'
      : 'bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 flex items-center gap-2',
    addSectionBtn: isDarkMode
      ? 'bg-green-600 text-white px-6 py-3 rounded-md hover:bg-green-500 transition-colors duration-200 flex items-center gap-2 shadow-sm'
      : 'bg-green-600 text-white px-6 py-3 rounded-md hover:bg-green-700 transition-colors duration-200 flex items-center gap-2 shadow-sm',
    importBtn: isDarkMode
      ? 'bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-500 transition-colors duration-200 flex items-center gap-2 shadow-sm'
      : 'bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition-colors duration-200 flex items-center gap-2 shadow-sm',
    amountCard: isDarkMode
      ? 'bg-gray-800 rounded-lg shadow-md p-6 mb-6 border border-gray-700'
      : 'bg-white rounded-lg shadow-md p-6 mb-6',
    grandTotalBar: isDarkMode
      ? 'mt-6 bg-gray-800 p-4 rounded-lg shadow-md border border-gray-700'
      : 'mt-6 bg-blue-50 p-4 rounded-lg shadow-md',
    submitBtn: isDarkMode
      ? 'bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-500 transition-colors duration-200 font-semibold shadow-sm'
      : 'bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition-colors duration-200 font-semibold shadow-sm',
    // Dashboard section
    dashboardSection: isDarkMode ? 'mb-8 mt-12' : 'mb-8 mt-12',
    dashboardHeading: isDarkMode ? 'text-2xl font-bold text-gray-100 flex items-center' : 'text-2xl font-bold text-gray-800 flex items-center',
    dashboardSubtext: isDarkMode ? 'text-sm text-gray-400' : 'text-sm text-gray-600',
    refreshBtn: isDarkMode
      ? 'bg-gray-700 text-blue-400 px-3 py-1 rounded-md hover:bg-gray-600 transition-colors flex items-center'
      : 'bg-blue-50 text-blue-600 px-3 py-1 rounded-md hover:bg-blue-100 transition-colors flex items-center',
    statsGradient: isDarkMode
      ? 'bg-gray-800 rounded-lg shadow-md p-4 mb-6 border border-gray-700'
      : 'bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg shadow-md p-4 mb-6',
    statsHeading: isDarkMode
      ? 'text-lg font-semibold text-gray-100 mb-4 flex items-center'
      : 'text-lg font-semibold text-gray-800 mb-4 flex items-center',
    statsInnerCard: isDarkMode
      ? 'bg-gray-700 p-4 rounded-lg shadow-sm border border-gray-600'
      : 'bg-white p-4 rounded-lg shadow-sm',
    statsLabel: isDarkMode ? 'text-sm text-gray-400 mb-1' : 'text-sm text-gray-500 mb-1',
    statsBigCard: isDarkMode
      ? 'bg-gray-800 rounded-lg shadow-md p-5 border border-gray-700'
      : 'bg-white rounded-lg shadow-md p-5',
    statsBigTitle: isDarkMode ? 'text-sm font-medium text-gray-400 uppercase tracking-wider' : 'text-sm font-medium text-gray-500 uppercase tracking-wider',
    statsBigValue: isDarkMode ? 'text-3xl font-bold text-gray-100 mt-2' : 'text-3xl font-bold text-gray-800 mt-2',
    statsIconBg: (color) => isDarkMode ? `p-2 bg-${color}-900/40 rounded-lg` : `p-2 bg-${color}-50 rounded-lg`,
    // List section
    listCard: isDarkMode
      ? 'mt-8 bg-gray-800 rounded-lg shadow-md p-6 border border-gray-700'
      : 'mt-8 bg-white rounded-lg shadow-md p-6',
    listHeading: isDarkMode ? 'text-2xl font-bold text-gray-100' : 'text-2xl font-bold text-gray-800',
    exportBtn: isDarkMode
      ? 'px-4 py-2 bg-green-700 text-white rounded-lg hover:bg-green-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2'
      : 'px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2',
    searchInput: isDarkMode
      ? 'pl-9 pr-4 py-2 border border-gray-600 bg-gray-700 text-gray-100 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 w-full md:w-64 placeholder-gray-400'
      : 'pl-9 pr-4 py-2 border rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 w-full md:w-64',
    filterBtn: (active) => isDarkMode
      ? `px-4 py-2 rounded-lg flex items-center gap-2 transition-all duration-200 ${active ? 'bg-blue-900/50 text-blue-300 shadow-inner' : 'bg-gray-700 text-gray-300 border border-gray-600 shadow-sm hover:bg-gray-600'}`
      : `px-4 py-2 rounded-lg flex items-center gap-2 transition-all duration-200 ${active ? 'bg-blue-100 text-blue-700 shadow-inner' : 'bg-white text-gray-700 border shadow-sm hover:bg-gray-50'}`,
    filterPanel: isDarkMode
      ? 'bg-gray-700 p-4 rounded-lg border border-gray-600 mb-6'
      : 'bg-gradient-to-r from-gray-50 to-blue-50 p-4 rounded-lg border border-gray-200 mb-6 animate-fadeIn',
    filterLabel: isDarkMode ? 'block text-sm font-medium text-gray-300 mb-1' : 'block text-sm font-medium text-gray-700 mb-1',
    filterInput: isDarkMode
      ? 'w-full px-3 py-2 border border-gray-600 bg-gray-600 text-gray-100 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500'
      : 'w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500',
    filterApplyBtn: isDarkMode
      ? 'bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-500 transition-colors duration-200 flex items-center gap-2 flex-1'
      : 'bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors duration-200 flex items-center gap-2 flex-1',
    filterResetBtn: isDarkMode
      ? 'bg-gray-600 text-gray-200 px-4 py-2 rounded-md hover:bg-gray-500 transition-colors duration-200'
      : 'bg-gray-200 text-gray-600 px-4 py-2 rounded-md hover:bg-gray-300 transition-colors duration-200',
    viewToggleBg: isDarkMode ? 'flex rounded-lg overflow-hidden border border-gray-600' : 'flex rounded-lg overflow-hidden border border-gray-300',
    viewToggleActive: isDarkMode ? 'px-3 py-1.5 text-sm font-medium bg-blue-600 text-white' : 'px-3 py-1.5 text-sm font-medium bg-blue-600 text-white',
    viewToggleInactive: isDarkMode ? 'px-3 py-1.5 text-sm font-medium bg-gray-700 text-gray-300 hover:bg-gray-600' : 'px-3 py-1.5 text-sm font-medium bg-white text-gray-600 hover:bg-gray-100',
    paginationBtn: isDarkMode
      ? 'flex items-center px-3 py-1 bg-blue-600 text-white rounded disabled:opacity-50 hover:bg-blue-500'
      : 'flex items-center px-3 py-1 bg-blue-500 text-white rounded disabled:opacity-50',
    paginationText: isDarkMode ? 'text-sm text-gray-400' : 'text-sm text-gray-600',
    paginationSelect: isDarkMode ? 'px-3 py-1 border border-gray-600 bg-gray-700 text-gray-200 rounded-md' : 'px-3 py-1 border rounded-md',
    // Grid card for quotation list
    gridCard: isDarkMode
      ? 'bg-gray-800 border border-gray-700 rounded-xl shadow-sm hover:shadow-lg hover:border-gray-600 transition-all duration-300 p-5'
      : 'bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 p-5',
    gridCardId: isDarkMode ? 'text-lg font-bold text-gray-100' : 'text-lg font-bold text-gray-800',
    gridCardAmount: isDarkMode ? 'text-lg font-bold text-green-400' : 'text-lg font-bold text-green-600',
    gridCardLabel: isDarkMode ? 'text-xs text-gray-500' : 'text-xs text-gray-400',
    gridCardRecipient: isDarkMode ? 'text-sm font-medium text-gray-200 truncate' : 'text-sm font-medium text-gray-700 truncate',
    gridCardSub: isDarkMode ? 'text-xs text-gray-500' : 'text-xs text-gray-500',
    gridCardActionBtn: isDarkMode
      ? 'p-2 rounded-lg hover:bg-gray-700 transition-colors'
      : 'p-2 rounded-lg hover:bg-gray-100 transition-colors',
    // Status badge dark mode variants
    statusBadge: (status) => {
      const map = {
        'COMPLETED': isDarkMode ? 'bg-green-900/40 text-green-300' : 'bg-green-100 text-green-800',
        'PARTIAL-COMPLETE': isDarkMode ? 'bg-yellow-900/40 text-yellow-300' : 'bg-yellow-100 text-yellow-800',
        'PENDING': isDarkMode ? 'bg-blue-900/40 text-blue-300' : 'bg-blue-100 text-blue-800',
        'CANCELLED': isDarkMode ? 'bg-red-900/40 text-red-300' : 'bg-red-100 text-red-800',
        'REJECTED': isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-800',
        'REFFOLLOW': isDarkMode ? 'bg-purple-900/40 text-purple-300' : 'bg-purple-100 text-purple-800',
      };
      return `inline-flex px-2 py-1 text-xs font-semibold rounded-full ${map[status] || (isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-800')}`;
    },
    // Section action buttons
    sectionActionBtn: isDarkMode ? 'text-gray-400 hover:text-gray-200 disabled:opacity-50' : 'text-gray-500 hover:text-gray-700 disabled:opacity-50',
    deleteBtn: isDarkMode ? 'text-red-400 hover:text-red-300 p-2' : 'text-red-500 hover:text-red-700 p-2',
    replicateBtn: isDarkMode ? 'text-blue-400 hover:text-blue-300 p-2' : 'text-blue-500 hover:text-blue-700 p-2',
    // Empty state
    emptyStateText: isDarkMode ? 'text-gray-400 text-lg' : 'text-gray-500 text-lg',
    emptyStateSub: isDarkMode ? 'text-gray-500 text-sm mt-1' : 'text-gray-400 text-sm mt-1',
    emptyStateIcon: isDarkMode ? 'w-12 h-12 text-gray-600 mb-3' : 'w-12 h-12 text-gray-300 mb-3',
    // Modal dark
    modalOverlay: 'fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center p-4 backdrop-blur-sm',
    modalCard: isDarkMode
      ? 'bg-gray-800 rounded-xl w-full max-w-5xl max-h-[90vh] flex flex-col shadow-2xl border border-gray-700'
      : 'bg-white rounded-xl w-full max-w-5xl max-h-[90vh] flex flex-col shadow-2xl',
    modalHeader: isDarkMode
      ? 'bg-gradient-to-r from-indigo-800 to-blue-900 px-6 py-4 flex justify-between items-center flex-shrink-0 rounded-t-xl'
      : 'bg-gradient-to-r from-indigo-600 to-blue-700 px-6 py-4 flex justify-between items-center flex-shrink-0 rounded-t-xl',
    modalStatusBar: isDarkMode
      ? 'bg-gray-700 px-6 py-3 sticky top-0 z-10 shadow-sm border-b border-gray-600 flex items-center justify-between'
      : 'bg-gradient-to-r from-gray-50 to-blue-50 px-6 py-3 sticky top-0 z-10 shadow-sm border-b border-gray-200 flex items-center justify-between',
  }), [isDarkMode]);

  // Dark-mode-aware react-select styles
  const customSelectStyles = useMemo(() => ({
    control: (provided, state) => ({
      ...provided,
      minHeight: '42px',
      border: state.isFocused ? `2px solid ${isDarkMode ? '#60a5fa' : '#3b82f6'}` : `1px solid ${isDarkMode ? '#4b5563' : '#d1d5db'}`,
      borderRadius: '0.5rem',
      boxShadow: state.isFocused ? `0 0 0 1px ${isDarkMode ? '#60a5fa' : '#3b82f6'}` : 'none',
      '&:hover': { borderColor: isDarkMode ? '#60a5fa' : '#3b82f6' },
      backgroundColor: isDarkMode ? '#374151' : 'white',
      fontSize: '14px',
    }),
    input: (provided) => ({ ...provided, margin: '0px', color: isDarkMode ? '#f3f4f6' : '#374151' }),
    singleValue: (provided) => ({ ...provided, color: isDarkMode ? '#f3f4f6' : '#374151' }),
    multiValue: (provided) => ({ ...provided, backgroundColor: isDarkMode ? '#4b5563' : '#e5e7eb', borderRadius: '6px' }),
    multiValueLabel: (provided) => ({ ...provided, color: isDarkMode ? '#f3f4f6' : '#374151', fontSize: '13px' }),
    multiValueRemove: (provided) => ({ ...provided, color: isDarkMode ? '#9ca3af' : '#6b7280', ':hover': { backgroundColor: isDarkMode ? '#6b7280' : '#d1d5db', color: isDarkMode ? '#f3f4f6' : '#374151' } }),
    placeholder: (provided) => ({ ...provided, color: isDarkMode ? '#9ca3af' : '#9ca3af' }),
    menu: (provided) => ({ ...provided, backgroundColor: isDarkMode ? '#1f2937' : 'white', borderColor: isDarkMode ? '#4b5563' : '#d1d5db', zIndex: 9999 }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? (isDarkMode ? '#3b82f6' : '#3b82f6') : state.isFocused ? (isDarkMode ? '#374151' : '#eff6ff') : 'transparent',
      color: state.isSelected ? 'white' : (isDarkMode ? '#f3f4f6' : '#374151'),
      '&:active': { backgroundColor: isDarkMode ? '#2563eb' : '#dbeafe' },
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (provided) => ({ ...provided, color: isDarkMode ? '#9ca3af' : '#6b7280', padding: '6px' }),
    clearIndicator: (provided) => ({ ...provided, color: isDarkMode ? '#9ca3af' : '#6b7280' }),
  }), [isDarkMode]);

  // Keyboard shortcut refs to avoid stale closures
  const shortcutRefs = useRef({});
  shortcutRefs.current = {
    handleSubmit,
    addSection,
    addItem,
    sections: form.sections,
    loading,
    modalVisible,
    setModalVisible,
    moveItem,
    moveSection,
    showDetailsModal,
    setShowDetailsModal,
    showRecipientModal,
    setShowRecipientModal,
    showItemDetailsModal,
    setShowItemDetailsModal,
    showChoiceImportModal,
    setShowChoiceImportModal,
  };

  // Global keyboard shortcuts
  useEffect(() => {
    const handler = (event) => {
      const r = shortcutRefs.current;
      const isInputActive = event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.tagName === 'SELECT' || event.target.isContentEditable;

      // Ctrl+S → Save / Create quotation
      if (event.ctrlKey && event.key === 's') {
        event.preventDefault();
        if (!r.loading) r.handleSubmit(event);
        return;
      }

      // Alt+N → Add new section
      if (event.altKey && event.key === 'n') {
        event.preventDefault();
        r.addSection();
        return;
      }

      // Alt+A → Add item to last section
      if (event.altKey && event.key === 'a') {
        event.preventDefault();
        if (r.sections.length > 0) r.addItem(r.sections.length - 1);
        return;
      }

      // Alt+ArrowUp/ArrowDown → Move focused item up/down
      if (event.altKey && !event.shiftKey && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) {
        event.preventDefault();
        const itemRow = document.activeElement?.closest('[data-item-pos]');
        if (itemRow) {
          const [si, ii] = itemRow.dataset.itemPos.split('-').map(Number);
          r.moveItem(si, ii, event.key === 'ArrowUp' ? 'up' : 'down');
        }
        return;
      }

      // Alt+Shift+ArrowUp/ArrowDown → Move focused section up/down
      if (event.altKey && event.shiftKey && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) {
        event.preventDefault();
        const sectionCard = document.activeElement?.closest('[data-section-idx]');
        if (sectionCard) {
          const si = Number(sectionCard.dataset.sectionIdx);
          r.moveSection(si, event.key === 'ArrowUp' ? 'up' : 'down');
        }
        return;
      }

      // Escape → close open modals
      if (event.key === 'Escape' && !isInputActive) {
        if (r.showDetailsModal) { r.setShowDetailsModal(false); return; }
        if (r.showRecipientModal) { r.setShowRecipientModal(false); return; }
        if (r.showItemDetailsModal) { r.setShowItemDetailsModal(false); return; }
        if (r.showChoiceImportModal) { r.setShowChoiceImportModal(false); return; }
        if (r.modalVisible.open) { r.setModalVisible({ open: false, func: null }); return; }
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, []);

  // Helper: get status badge classes
  const getStatusBadge = (status) => dc.statusBadge(status);

  return (
    <div className={`${dc.page} ${isDarkMode ? 'tq-dark-page' : ''}`}>
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-3">
        <h1 className={dc.headingText}>Tally Quotation</h1>
        {/* Keyboard Shortcuts Tooltip */}
        <div className="relative group">
          <button type="button" className={`px-3 py-2 text-sm rounded-lg transition-colors flex items-center gap-1.5 ${isDarkMode ? 'bg-blue-900/40 text-blue-300 hover:bg-blue-900/60' : 'bg-blue-100 text-blue-700 hover:bg-blue-200'}`} title="Keyboard shortcuts">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l4-4 4 4m0 6l-4 4-4-4" /></svg>
            Shortcuts
          </button>
          <div className="absolute top-full right-0 mt-2 w-72 p-3 text-xs rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 bg-gray-900 text-white">
            <div className="font-medium mb-2">⌨️ Keyboard Shortcuts</div>
            <div className="space-y-1.5">
              <div className="flex justify-between items-center"><span>Save Quotation:</span><span className="font-mono bg-gray-700 px-1.5 py-0.5 rounded text-xs">Ctrl+S</span></div>
              <div className="flex justify-between items-center"><span>Add New Section:</span><span className="font-mono bg-gray-700 px-1.5 py-0.5 rounded text-xs">Alt+N</span></div>
              <div className="flex justify-between items-center"><span>Add Item to Last Section:</span><span className="font-mono bg-gray-700 px-1.5 py-0.5 rounded text-xs">Alt+A</span></div>
              <div className="flex justify-between items-center"><span>Move Item Up/Down:</span><span className="font-mono bg-gray-700 px-1.5 py-0.5 rounded text-xs">Alt+↑↓</span></div>
              <div className="flex justify-between items-center"><span>Move Section Up/Down:</span><span className="font-mono bg-gray-700 px-1.5 py-0.5 rounded text-xs">Alt+Shift+↑↓</span></div>
              <div className="flex justify-between items-center"><span>Close Modal:</span><span className="font-mono bg-gray-700 px-1.5 py-0.5 rounded text-xs">Esc</span></div>
            </div>
            <div className="absolute bottom-full right-4 w-0 h-0 border-l-4 border-r-4 border-b-4 border-l-transparent border-r-transparent border-b-gray-900"></div>
          </div>
        </div>
      </div>
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* First row: Recipient Type, Recipient, Reference, Transporter - Inline */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className={dc.labelBase}>
              Recipient Type
            </label>
            <Select
              value={{ value: form.recipientType, label: form.recipientType }}
              onChange={(selectedOption) => setForm({ 
                ...form, 
                recipientType: selectedOption.value, 
                recipient: null 
              })}
              options={[
                { value: 'Customer', label: 'Customer' },
                { value: 'Dealer', label: 'Dealer' }
              ]}
              className="w-full"
              isSearchable={false}
              placeholder="Select Recipient Type"
              styles={customSelectStyles}
            />
          </div>
          <div>
            <label className={dc.labelBase}>
              Select Recipient <span className="text-red-500">*</span>
            </label>
            <button
              type="button"
              onClick={() => setShowRecipientModal(true)}
              className={`w-full p-2 border rounded-lg text-left transition-colors ${isDarkMode ? 'border-gray-600 bg-gray-700 hover:bg-gray-600 focus:ring-2 focus:ring-blue-500' : 'border-gray-300 bg-white hover:bg-gray-50 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'}`}
            >
              <div className="flex items-center justify-between">
                <span 
                  className={`${form.recipient ? dc.textPrimary : dc.textMuted} truncate pr-2`}
                  title={form.recipient ? form.recipient.label : `Select ${form.recipientType}`}
                >
                  {form.recipient 
                    ? form.recipient.label 
                    : `Select ${form.recipientType}`
                  }
                </span>
                <svg className="w-5 h-5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </button>
          </div>
          <div>
            <label className={dc.labelBase}>
              Reference (Optional)
            </label>
            <button
              type="button"
              onClick={() => setShowReferenceModal(true)}
              className={`w-full p-2 border rounded-lg text-left transition-colors ${isDarkMode ? 'border-gray-600 bg-gray-700 hover:bg-gray-600 focus:ring-2 focus:ring-blue-500' : 'border-gray-300 bg-white hover:bg-gray-50 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'}`}
            >
              <div className="flex items-center justify-between">
                <span className={`${form.reference ? dc.textPrimary : dc.textMuted} truncate pr-2`}>
                  {form.reference
                    ? (form.referenceName || references.find(r => r._id === form.reference)?.name || 'Selected')
                    : 'Select Reference'
                  }
                </span>
                <div className="flex items-center gap-1 flex-shrink-0">
                  {form.reference && (
                    <span
                      onClick={(e) => { e.stopPropagation(); setForm(prev => ({ ...prev, reference: null, referenceName: '' })); }}
                      className="text-gray-400 hover:text-red-500 cursor-pointer p-0.5"
                    >
                      <FaTimes className="w-3 h-3" />
                    </span>
                  )}
                  <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
            </button>
          </div>
          <div>
            <label className={dc.labelBase}>
              Transporter (Optional)
            </label>
            <button
              type="button"
              onClick={() => setShowTransporterModal(true)}
              className={`w-full p-2 border rounded-lg text-left transition-colors ${isDarkMode ? 'border-gray-600 bg-gray-700 hover:bg-gray-600 focus:ring-2 focus:ring-blue-500' : 'border-gray-300 bg-white hover:bg-gray-50 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'}`}
            >
              <div className="flex items-center justify-between">
                <span className={`${form.transporterName ? dc.textPrimary : dc.textMuted} truncate pr-2`}>
                  {form.transporterName
                    ? (form.transporterDisplayName || transporters.find(t => t._id === form.transporterName)?.name || 'Selected')
                    : 'Select Transporter'
                  }
                </span>
                <div className="flex items-center gap-1 flex-shrink-0">
                  {form.transporterName && (
                    <span
                      onClick={(e) => { e.stopPropagation(); setForm(prev => ({ ...prev, transporterName: null, transporterDisplayName: '' })); }}
                      className="text-gray-400 hover:text-red-500 cursor-pointer p-0.5"
                    >
                      <FaTimes className="w-3 h-3" />
                    </span>
                  )}
                  <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
            </button>
          </div>
        </div>

        {/* Second row: Salesmen, Remarks, Site Address - Inline */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className={dc.labelBase}>
              Salesmen
            </label>
            <Select
              isMulti
              options={employees.map(emp => ({
                value: emp._id,
                label: emp.name
              }))}
              value={form.salesmen.map(id => ({
                value: id,
                label: employees.find(emp => emp._id === id)?.name || ''
              }))}
              onChange={(selected) => {
                setForm(prev => ({
                  ...prev,
                  salesmen: selected.map(option => option.value)
                }));
              }}
              className="w-full"
              placeholder="Select salesmen..."
              styles={customSelectStyles}
            />
          </div>
          <div>
            <label className={dc.labelBase}>
              Remarks
            </label>
            <textarea
              className="w-full p-2 border rounded-md resize-none"
              value={form.remarks}
              onChange={(e) => setForm({ ...form, remarks: e.target.value })}
              rows={2}
              placeholder="Add remarks here..."
            />
          </div>
          <div>
            <label className={dc.labelBase}>
              Site Address (Optional)
            </label>
            <textarea
              className="w-full p-2 border rounded-md resize-none focus:ring-blue-500 focus:border-blue-500"
              value={form.siteAddress || ''}
              onChange={(e) => setForm({ ...form, siteAddress: e.target.value })}
              rows={2}
              placeholder="Enter site address"
            />
          </div>
        </div>
        {form.sections.map((section, sectionIndex) => (
          <div key={sectionIndex} data-section-idx={sectionIndex} className={dc.sectionCard}>
            <div className={dc.sectionHeader}>
              <div className="flex items-center gap-4 flex-1">
                <input
                  type="text"
                  placeholder="Section Name"
                  className={dc.sectionNameInput}
                  value={section.name}
                  onChange={(e) => handleSectionChange(sectionIndex, 'name', e.target.value)}
                />
              </div>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => copySection(sectionIndex)}
                  className="text-violet-500 hover:text-violet-700 p-2"
                  title="Copy Section"
                >
                  <FaCopy />
                </button>
                <button
                  type="button"
                  onClick={() => replicateSection(sectionIndex)}
                  className="text-blue-500 hover:text-blue-700 p-2"
                  title="Replicate Section"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z" />
                    <path d="M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z" />
                  </svg>
                </button>
                <button
                  type="button"
                  onClick={() => deleteSection(sectionIndex)}
                  className={dc.deleteBtn}
                >
                  <FaTrash />
                </button>
                <div className="flex flex-col">
                  <button
                    type="button"
                    onClick={() => moveSection(sectionIndex, 'up')}
                    disabled={sectionIndex === 0}
                    className={dc.sectionActionBtn}
                  >
                    <FaCaretUp />
                  </button>
                  <button
                    type="button"
                    onClick={() => moveSection(sectionIndex, 'down')}
                    disabled={sectionIndex === form.sections.length - 1}
                    className={dc.sectionActionBtn}
                  >
                    <FaCaretDown />
                  </button>
                </div>
              </div>
            </div>
            <div className={dc.tableBg}>
              <table className="min-w-full divide-y divide-gray-200">
                <thead className={dc.tableHead}><tr>
                  <th className={dc.tableHeadTh}>Item</th>
                  <th className={dc.tableHeadTh}>Print Name</th>
                  <th className={dc.tableHeadTh}>Application Area</th>
                  <th className={dc.tableHeadTh}>Quantity</th>
                  <th className={dc.tableHeadTh}>Listed Price</th> {/* Changed from Rate */}
                  <th className={dc.tableHeadTh}>Discount %</th>
                  <th className={dc.tableHeadTh}>Price Details</th>
                  <th className={dc.tableHeadTh}>Actions</th>
                </tr></thead>
                <tbody>
                  {section.items.map((item, itemIndex) => {
                    const selectedItem = filteredItems.find(i => i._id === item.item);
                    const parameter = item.parameter || selectedItem?.parameter;
                    const calculationType = parameter?.calculationType;
                    return (
                      <tr key={itemIndex} data-item-pos={`${sectionIndex}-${itemIndex}`}>
                        <td className="px-4 py-2">
                          <button
                            type="button"
                            onClick={() => openItemModal(sectionIndex, itemIndex)}
                            className={dc.itemBtn}
                          >
                            {item.itemName || 'Select Item'} {/* Use itemName here */}
                          </button>
                          {!item.item && (
                            <div className={`text-xs mt-1 font-medium ${isDarkMode ? 'text-amber-300' : 'text-amber-700'}`}>
                              Item not selected
                            </div>
                          )}
                          {item.item && (
                            <div className={`text-xs mt-1 font-medium ${isDarkMode ? 'text-slate-400' : 'text-gray-500'}`}>
                              Stock: {item.reorderStatus?.netAvailable ? (
                                <span className={item.reorderStatus.netAvailable.base > 0 ? (isDarkMode ? 'text-emerald-400' : 'text-emerald-600') : (isDarkMode ? 'text-red-400' : 'text-red-600')}>
                                  {item.reorderStatus.netAvailable.base} {item.reorderStatus.netAvailable.unit || item.baseUnits}
                                  {item.reorderStatus.netAvailable.additional > 0 && ` + ${item.reorderStatus.netAvailable.additional} ${item.additionalUnits || 'PCS'}`}
                                </span>
                              ) : item.closingBalance ? (
                                <span className={parseFloat(item.closingBalance) > 0 ? (isDarkMode ? 'text-emerald-400' : 'text-emerald-600') : (isDarkMode ? 'text-red-400' : 'text-red-600')}>
                                  {item.closingBalance} {item.baseUnits}
                                </span>
                              ) : (
                                <span className={isDarkMode ? 'text-slate-500' : 'text-gray-400'}>N/A</span>
                              )}
                            </div>
                          )}
                        </td>
                        <td className="px-4 py-2">
                          <div className="flex items-center gap-2">
                            <textarea
                              id={`printName-${sectionIndex}-${itemIndex}`}
                              value={item.customName || ''}
                              onChange={(e) => {
                                handleItemChange(sectionIndex, itemIndex, 'customName', e.target.value);
                                autoResizeTextarea(e.target);
                              }}
                              onInput={(e) => autoResizeTextarea(e.target)}
                              className="w-full p-2 border rounded-md resize-none overflow-hidden"
                              rows={1}
                              style={{ minHeight: '40px' }}
                              placeholder="Print Name"
                            />
                          </div>
                        </td>
                        <td className="px-4 py-2">
                          <textarea
                            id={`appArea-${sectionIndex}-${itemIndex}`}
                            value={item.applicationArea || ''}
                            onChange={(e) => {
                              handleItemChange(sectionIndex, itemIndex, 'applicationArea', e.target.value.toUpperCase());
                              autoResizeTextarea(e.target);
                            }}
                            onInput={(e) => autoResizeTextarea(e.target)}
                            className="w-full p-2 border rounded-md resize-none overflow-hidden"
                            rows={1}
                            style={{ minHeight: '40px' }}
                            placeholder="Application Area"
                          />
                        </td>
                        <td className="px-4 py-2">
                          {calculationType === 'pcsPerBox' ? (
                            <div className="flex flex-col space-y-1">
                              <div className="flex items-center space-x-2">
                                <div className="flex items-center">
                                  <label className="text-xs text-gray-500 mr-1">Box:</label>
                                  <input
                                    type="number"
                                    value={item.boxes || 0}
                                    onChange={(e) => handleItemChange(sectionIndex, itemIndex, 'boxes', e.target.value)}
                                    className="w-16 p-1 border rounded-md text-sm"
                                    min="0"
                                  />
                                </div>
                                <div className="flex items-center">
                                  <label className="text-xs text-gray-500 mr-1">Pcs:</label>
                                  <input
                                    type="number"
                                    value={item.pieces || 0}
                                    onChange={(e) => handleItemChange(sectionIndex, itemIndex, 'pieces', e.target.value)}
                                    className="w-16 p-1 border rounded-md text-sm"
                                    min="0"
                                  />
                                </div>
                              </div>
                              {item.coverageArea > 0 && (
                                <div className="text-xs text-gray-500">
                                  Coverage: {item.coverageArea}
                                </div>
                              )}
                            </div>
                          ) : (
                            <div className="flex items-center space-x-2">
                              {/* make a number input which offers three digits values */}
                              <input
                                type="number"
                                value={item.quantity || 0}
                                onChange={(e) => handleItemChange(sectionIndex, itemIndex, 'quantity', e.target.value)}
                                className="w-20 p-2 border rounded-md"
                                step="0.000"
                              />
                              <select
                                value={item.unit || 'pcs'}
                                onChange={(e) => handleItemChange(sectionIndex, itemIndex, 'unit', e.target.value)}
                                className="p-2 border rounded-md text-sm"
                              >
                                <option value="pcs">PCS</option>
                                <option value="box">BOX</option>
                                <option value="bag">BAG</option>
                                <option value="pkt">PKT</option>
                                <option value="pair">PAIR</option>
                                <option value="roll">ROLL</option>
                                <option value="set">SET</option>
                                <option value="bkt">BKT</option>
                                <option value="mtr">MTR</option>
                                <option value="sh">SH</option>
                                <option value="can">CAN</option>
                                <option value="kg">KG</option>
                                <option value="ltr">LTR</option>
                                <option value="bundles">BUNDLES</option>
                                <option value="bottle">BOTTLE</option>
                                <option value="drums">DRUMS</option>
                                <option value="sq.ft">SQ.FT</option>
                                <option value="sq.mtr">SQ.MTR</option>
                                <option value="fts">FTS</option>
                                <option value="nos">NOS</option>
                                <option value="rft">RFT</option>
                              </select>
                            </div>
                          )}
                        </td>
                        <td className="px-4 py-2">
                          <input
                            type="number"
                            value={item.listedPrice || 0}
                            onChange={(e) => handleItemChange(sectionIndex, itemIndex, 'listedPrice', e.target.value)}
                            className="w-24 p-2 border rounded-md"
                            min="0"
                            step="any"
                          />
                        </td>
                        <td className="px-4 py-2">
                          <input
                            type="number"
                            value={item.discount || 0}
                            onChange={(e) => handleItemChange(sectionIndex, itemIndex, 'discount', e.target.value)}
                            className="w-24 p-2 border rounded-md"
                            min="0"
                            max="100"
                            step="0.01"
                            placeholder="%"
                          />
                        </td>
                        <td className="px-4 py-2">
                          <div className="space-y-2">
                            {item.parameter?.calculationType === 'pcsPerBox' ? (
                              <>
                                <div className="text-sm">
                                  <span className="text-gray-600">Box Price:</span>
                                  <span className="text-purple-600">₹{addCommas(item.listedPrice)}</span>
                                </div>
                                <div className="text-sm">
                                  <span className="text-gray-600">Piece Price:</span>
                                  <span className="text-purple-600">₹{addCommas(item.listedPrice / item.parameter.piecesPerBox)}</span>
                                </div>
                                <div className="text-sm">
                                  <span className="text-gray-600">Box Total ({item.boxes} × ₹{addCommas(item.listedPrice)}):</span>
                                  <span className="text-purple-600">₹{addCommas(item.boxes * item.listedPrice)}</span>
                                </div>
                                {item.pieces > 0 && (
                                  <div className="text-sm">
                                    <span className="text-gray-600">
                                      Piece Total ({item.pieces} × ₹{addCommas(item.listedPrice / item.parameter.piecesPerBox)}):
                                    </span>
                                    <span className="text-purple-600">
                                      ₹{addCommas(item.pieces * (item.listedPrice / item.parameter.piecesPerBox))}
                                    </span>
                                  </div>
                                )}
                              </>
                            ) : null}
                            <div className="text-sm font-semibold pt-1 border-t">
                              <span className="text-gray-600">Listed Total:</span>
                              <span className="text-purple-600">₹{addCommas(item.listedPriceTotal)}</span>
                            </div>
                            <div className="text-sm font-semibold">
                              <span className="text-gray-600">Offer Total:</span>
                              <span className="text-green-600">₹{addCommas(item.offerPriceTotal)}</span>
                            </div>
                          </div>
                        </td>
                        <td className="px-4 py-2">
                          <div className="flex items-center space-x-2">
                            <div className="flex flex-col">
                              <button
                                type="button"
                                onClick={() => moveItem(sectionIndex, itemIndex, 'up')}
                                disabled={itemIndex === 0}
                                className="text-gray-500 hover:text-gray-700 disabled:opacity-50"
                              >
                                <FaCaretUp />
                              </button>
                              <button
                                type="button"
                                onClick={() => moveItem(sectionIndex, itemIndex, 'down')}
                                disabled={itemIndex === section.items.length - 1}
                                className="text-gray-500 hover:text-gray-700 disabled:opacity-50"
                              >
                                <FaCaretDown />
                              </button>
                            </div>
                            <button
                              type="button"
                              onClick={() => deleteItem(sectionIndex, itemIndex)}
                              className="text-red-500 hover:text-red-700"
                              title="Delete Item"
                            >
                              <FaTrash />
                            </button>
                            <button
                              type="button"
                              onClick={() => copyItem(sectionIndex, itemIndex)}
                              className={`${isDarkMode ? 'text-violet-300 hover:text-violet-200' : 'text-violet-600 hover:text-violet-800'}`}
                              title="Copy Item"
                            >
                              <FaCopy />
                            </button>
                            <button
                              type="button"
                              title="Replicate Item"
                              className={`p-1 rounded border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-blue-300 hover:bg-blue-500' : 'bg-white border-gray-300 text-blue-600 hover:bg-blue-100'} transition-colors`}
                              onClick={() => replicateItem(sectionIndex, itemIndex)}
                            >
                              <span className="sr-only">Replicate Item</span>
                              {/* Material Design Duplicate Icon */}
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z" />
                    <path d="M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z" />
                  </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className={dc.sectionFooter}>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => addItem(sectionIndex)}
                  className={dc.addItemBtn}
                >
                  <FaPlus className="text-sm" /> Add Item
                </button>
                <button
                  type="button"
                  onClick={() => pasteItem(sectionIndex)}
                  disabled={!copiedItem}
                  className={`px-4 py-2 rounded-md flex items-center gap-2 border transition-colors ${isDarkMode ? 'border-teal-700 text-teal-300 hover:bg-teal-900/30 disabled:opacity-40' : 'border-teal-300 text-teal-700 hover:bg-teal-50 disabled:opacity-40'}`}
                >
                  <FaPaste className="text-sm" /> Paste Item
                </button>
              </div>
              <div className="text-right">
                <p className={`text-sm ${dc.textSecondary}`}>Listed Price Total: ₹{addCommas(section.listedPriceTotal)}</p>
                <p className={`text-sm font-semibold ${dc.textSecondary}`}>Offer Price Total: ₹{addCommas(section.offerPriceTotal)}</p>
              </div>
            </div>
          </div>
        ))}
        <div className="flex justify-center my-6">
          <div className="flex gap-4">
            <button
              type="button"
              onClick={addSection}
              className={dc.addSectionBtn}
            >
              <FaPlus className="text-sm" />
              Add New Section
            </button>
            <button
              type="button"
              onClick={openChoiceImportModal}
              className={dc.importBtn}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
              </svg>
              Import from Choices
            </button>
            <button
              type="button"
              onClick={pasteSection}
              disabled={!copiedSection}
              className={`px-6 py-3 rounded-md transition-colors duration-200 flex items-center gap-2 shadow-sm border ${isDarkMode ? 'border-teal-700 text-teal-300 hover:bg-teal-900/30 disabled:opacity-40' : 'border-teal-300 text-teal-700 hover:bg-teal-50 disabled:opacity-40'}`}
            >
              <FaPaste className="text-sm" />
              Paste Section
            </button>
          </div>
        </div>
        <div className={dc.amountCard}>
          <h3 className={`text-lg font-semibold mb-4 ${dc.textPrimary}`}>Amount Breakdown</h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div>
              <label className={dc.labelBase}>
                Cartage
              </label>
              <input
                type="number"
                step="0.01"
                value={form.cartage || 0}
                onChange={(e) => handleChargeChange('cartage', e.target.value)}
                className={dc.inputBase}
              />
              <p className={`text-sm mt-1 ${dc.textMuted}`}>
                +18% GST: ₹{addCommas((form.cartage || 0) * 0.18)}
              </p>
            </div>
            <div>
              <label className={dc.labelBase}>
                Packing & Forwarding
              </label>
              <input
                type="number"
                step="0.01"
                value={form.packingAndForwarding || 0}
                onChange={(e) => handleChargeChange('packingAndForwarding', e.target.value)}
                className={dc.inputBase}
              />
              <p className={`text-sm mt-1 ${dc.textMuted}`}>
                +18% GST: ₹{addCommas((form.packingAndForwarding || 0) * 0.18)}
              </p>
            </div>
            <div>
              <label className={dc.labelBase}>
                Labour
              </label>
              <input
                type="number"
                step="0.01"
                value={form.labour || 0}
                onChange={(e) => handleChargeChange('labour', e.target.value)}
                className={dc.inputBase}
              />
              <p className={`text-sm mt-1 ${dc.textMuted}`}>
                +18% GST: ₹{addCommas((form.labour || 0) * 0.18)}
              </p>
            </div>
            <div>
              <label className={dc.labelBase}>
                Round Off
              </label>
              <input
                type="number"
                step="0.01"
                value={form.roundOff || 0}
                onChange={(e) => handleChargeChange('roundOff', e.target.value)}
                className={dc.inputBase}
              />
            </div>
          </div>
        </div>
        <div className={`mt-6 ${dc.grandTotalBar}`}>
          <div className="flex justify-between items-center">
            <div className="flex flex-col">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <span className={`text-sm ${dc.textSecondary}`}>Listed Price Total</span>
                  <p className="text-2xl font-bold text-purple-600">
                    ₹{typeof form.listedPriceGrandTotal === 'object' ? 
                      formatId(form.listedPriceGrandTotal) : 
                      addCommas(form.listedPriceGrandTotal)}
                  </p>
                </div>
                <div>
                  <span className={`text-sm ${dc.textSecondary}`}>Total Amount</span>
                  <p className="text-2xl font-bold text-green-600">
                    ₹{typeof form.totalAmount === 'object' ? 
                      formatId(form.totalAmount) : 
                      addCommas(form.totalAmount)}
                  </p>
                </div>
              </div>
            </div>
            <button
              type="submit"
              className={dc.submitBtn}
            >
              Save Quotation
            </button>
          </div>
        </div>
      </form>
      <div className={`mb-8 mt-12 ${dc.dashboardSection}`}>
        <div className="flex justify-between items-center mb-4">
          <div>
            <h2 className={`text-2xl font-bold flex items-center ${dc.dashboardHeading}`}>
              <FaChartBar className="mr-2 text-blue-600" />
              My Quotation Dashboard
            </h2>
            <p className={`text-sm ${dc.dashboardSubtext}`}>
              Showing only your created quotations and statistics
            </p>
          </div>
          <div className="flex items-center space-x-2">
            <button 
              onClick={fetchQuotationStats}
              className={dc.refreshBtn}
            >
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0  01-15.357-2m15.357 2H15" />
              </svg>
              Refresh Stats
            </button>
          </div>
        </div>
        {statsLoading ? (
          <div className="flex justify-center items-center h-48">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
          </div>
        ) : (
          <>
            <div className={dc.statsGradient}>
              <h3 className={`text-lg font-semibold mb-4 flex items-center ${dc.statsHeading}`}>
                <FaCalendarAlt className="mr-2 text-blue-600" />
                My Recent Quotation Activity
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className={dc.statsInnerCard}>
                  <div className={`text-sm mb-1 ${dc.statsLabel}`}>Quotations</div>
                  <div className="text-2xl font-bold text-blue-700">
                    {formatId(lastSevenDaysStats?.totalQuotations)}
                  </div>
                </div>
                <div className={dc.statsInnerCard}>
                  <div className={`text-sm mb-1 ${dc.statsLabel}`}>Total Value</div>
                  <div className="text-2xl font-bold text-green-700">
                    ₹{lastSevenDaysStats?.totalAmount || "0.00"}
                  </div>
                </div>
                <div className={dc.statsInnerCard}>
                  <div className={`text-sm mb-1 ${dc.statsLabel}`}>Avg. Value</div>
                  <div className="text-2xl font-bold text-purple-700">
                    ₹{lastSevenDaysStats?.avgAmount || "0.00"}
                  </div>
                </div>
                <div className={dc.statsInnerCard}>
                  <div className={`text-sm mb-1 ${dc.statsLabel}`}>Recipient Types</div>
                  <div className="flex items-center justify-between">
                    <div className="text-sm">
                      <span className="font-semibold text-blue-700">{lastSevenDaysStats?.customerCount || 0}</span>
                      <span className="text-gray-500 ml-1">Customers</span>
                    </div>
                    <div className="text-sm">
                      <span className="font-semibold text-indigo-700">{lastSevenDaysStats?.dealerCount || 0}</span>
                      <span className="text-gray-500 ml-1">Dealers</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              <div className={dc.statsBigCard}>
                <div className="flex justify-between items-start">
                  <div>
                    <h4 className={dc.statsBigTitle}>My Total Quotations</h4>
                    <p className={`text-3xl font-bold mt-2 ${dc.statsBigValue}`}>
                      {typeof quoteStats?.totalQuotations === 'object' ? 
                        formatId(quoteStats?.totalQuotations) : 
                        quoteStats?.totalQuotations || 0}
                    </p>
                  </div>
                  <div className={dc.statsIconBg('blue')}>
                    <svg className="w-8 h-8 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </div>
                </div>
                <div className={`mt-4 flex items-center justify-between text-sm ${dc.statsLabel}`}>
                  <div>
                    <span className="text-gray-500">Customer:</span>
                    <span className="ml-1 font-medium">{quoteStats?.customerCount || 0}</span>
                  </div>
                  <div>
                    <span className="text-gray-500">Dealer:</span>
                    <span className="ml-1 font-medium">{quoteStats?.dealerCount || 0}</span>
                  </div>
                </div>
                <div className={`mt-3 pt-3 border-t ${isDarkMode ? 'border-gray-600' : 'border-gray-200'} text-xs flex justify-between`}>
                  <span className={isDarkMode ? 'text-green-300' : 'text-green-700'}>Completed: {quoteStats?.statusCounts?.completed || 0}</span>
                  <span className={isDarkMode ? 'text-yellow-300' : 'text-yellow-700'}>Partial: {quoteStats?.statusCounts?.partial || 0}</span>
                  <span className={isDarkMode ? 'text-blue-300' : 'text-blue-700'}>Pending: {quoteStats?.statusCounts?.pending || 0}</span>
                </div>
              </div>
              <div className={dc.statsBigCard}>
                <div className="flex justify-between items-start">
                  <div>
                    <h4 className={dc.statsBigTitle}>Total Amount</h4>
                    <p className={`text-3xl font-bold mt-2 ${dc.statsBigValue}`}>
                      ₹{quoteStats?.totalAmount || "0.00"}
                    </p>
                  </div>
                  <div className={dc.statsIconBg('green')}>
                    <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>
                <div className={`mt-4 text-sm ${dc.statsLabel}`}>
                  <div className="flex justify-between mb-1">
                    <span className="text-gray-500">Min Amount:</span>
                    <span className="font-medium">₹{quoteStats?.minAmount || "0.00"}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Max Amount:</span>
                    <span className="font-medium">₹{quoteStats?.maxAmount || "0.00"}</span>
                  </div>
                </div>
              </div>
              <div className={dc.statsBigCard}>
                <div className="flex justify-between items-start">
                  <div>
                    <h4 className={dc.statsBigTitle}>Average Value</h4>
                    <p className={`text-3xl font-bold mt-2 ${dc.statsBigValue}`}>
                      ₹{quoteStats?.avgAmount || "0.00"}
                    </p>
                  </div>
                  <div className={dc.statsIconBg('purple')}>
                    <svg className="w-8 h-8 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
                    </svg>
                  </div>
                </div>
                <div className={`mt-4 text-sm ${dc.statsLabel}`}>
                  <div className="flex justify-between mb-1">
                    <span className="text-gray-500">Customer Avg:</span>
                    <span className="font-medium">₹{quoteStats?.customerAmount && quoteStats?.customerCount ? 
                      formatNumberWithCommas(parseFloat(quoteStats.customerAmount.replace(/,/g, '')) / quoteStats.customerCount) : 
                      "0.00"}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Dealer Avg:</span>
                    <span className="font-medium">₹{quoteStats?.dealerAmount && quoteStats?.dealerCount ? 
                      formatNumberWithCommas(parseFloat(quoteStats.dealerAmount.replace(/,/g, '')) / quoteStats.dealerCount) : 
                      "0.00"}</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className={`mt-8 ${dc.listCard}`}>
        <div className="flex flex-col md:flex-row md:justify-between md:items-center space-y-4 md:space-y-0 mb-6">
          <h2 className={`text-2xl font-bold ${dc.listHeading}`}>My Recent Quotations</h2>
          <div className="flex flex-col md:flex-row gap-2 md:items-center">
            <button 
              onClick={exportAllQuotationsToExcel}
              disabled={loading}
              className={dc.exportBtn}
            >
              <FaFileDownload className="text-white" />
              <span>{loading ? 'Exporting...' : 'Export to Excel'}</span>
            </button>
            <div className="relative">
              <input
                type="text"
                placeholder="Search quotations..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className={`pl-9 pr-4 py-2 rounded-lg shadow-sm w-full md:w-64 ${dc.searchInput}`}
              />
              <FaSearch className="absolute left-3 top-3 text-gray-400" />
            </div>
            <button 
              onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
              className={dc.filterBtn(showAdvancedFilters)}
            >
              <FaFilter className={showAdvancedFilters ? 'text-blue-500' : 'text-gray-500'} />
              <span>{showAdvancedFilters ? 'Hide Filters' : 'Filters'}</span>
              {Object.values(advancedFilters).some(val => 
                val !== '' && val !== null && (Array.isArray(val) ? val.length > 0 : true)
              ) && !showAdvancedFilters && (
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-blue-500 text-xs text-white">
                  {Object.values(advancedFilters).filter(val => 
                    val !== '' && val !== null && (Array.isArray(val) ? val.length > 0 : true)
                  ).length}
                </span>
              )}
            </button>
            <div className={dc.viewToggleBg}>
              <button
                onClick={() => setViewMode('grid')}
                className={viewMode === 'grid' ? dc.viewToggleActive : dc.viewToggleInactive}
                title="Grid View"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                </svg>
              </button>
              <button
                onClick={() => setViewMode('list')}
                className={viewMode === 'list' ? dc.viewToggleActive : dc.viewToggleInactive}
                title="List View"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        {showAdvancedFilters && (
          <div className={dc.filterPanel}>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              <div>
                <label className={dc.filterLabel}>Recipient Type</label>
                <select
                  className={dc.filterInput}
                  value={advancedFilters.recipientType}
                  onChange={(e) => handleFilterChange('recipientType', e.target.value)}
                >
                  <option value="">All Types</option>
                  <option value="Customer">Customer</option>
                  <option value="Dealer">Dealer</option>
                </select>
              </div>
              <div>
                <label className={dc.filterLabel}>Salesman</label>
                <select
                  className={dc.filterInput}
                  value={advancedFilters.salesmanId}
                  onChange={(e) => handleFilterChange('salesmanId', e.target.value)}
                >
                  <option value="">All Salesmen</option>
                  {employees.map((employee) => (
                    <option key={employee._id} value={employee._id}>{employee.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className={dc.filterLabel}>Min Amount</label>
                <input
                  type="number"
                  className={dc.filterInput}
                  placeholder="Min Amount"
                  value={advancedFilters.minAmount}
                  onChange={(e) => handleFilterChange('minAmount', e.target.value)}
                />
              </div>
              <div>
                <label className={dc.filterLabel}>Max Amount</label>
                <input
                  type="number"
                  className={dc.filterInput}
                  placeholder="Max Amount"
                  value={advancedFilters.maxAmount}
                  onChange={(e) => handleFilterChange('maxAmount', e.target.value)}
                />
              </div>
              <div>
                <label className={dc.filterLabel}>Start Date</label>
                <DatePicker
                  selected={advancedFilters.startDate}
                  onChange={(date) => handleFilterChange('startDate', date)}
                  className={dc.filterInput}
                  placeholderText="Start Date"
                  dateFormat="dd/MM/yyyy"
                />
              </div>
              <div>
                <label className={dc.filterLabel}>End Date</label>
                <DatePicker
                  selected={advancedFilters.endDate}
                  onChange={(date) => handleFilterChange('endDate', date)}
                  className={dc.filterInput}
                  placeholderText="End Date"
                  dateFormat="dd/MM/yyyy"
                  minDate={advancedFilters.startDate}
                />
              </div>
              <div className="flex items-end gap-2">
                <button
                  onClick={applyFilters}
                  className={dc.filterApplyBtn}
                >
                  <FaSearch className="text-sm" />
                  Apply Filters
                </button>
                <button
                  onClick={resetAdvancedFilters}
                  className={dc.filterResetBtn}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        )}
        {loading ? (
          <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        ) : quotations.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-12">
            <svg className={`w-12 h-12 mb-3 ${dc.emptyStateIcon}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <p className={dc.emptyStateText}>You haven't created any quotations yet</p>
            <p className={dc.emptyStateSub}>Try adjusting your filters or create a new quotation</p>
          </div>
        ) : viewMode === 'grid' ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {quotations.map((quotation) => (
              <div
                key={quotation._id}
                className={dc.gridCard}
                onClick={() => handleViewQuotation(quotation._id)}
              >
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <span className={dc.gridCardId}>{safeDisplay(quotation.id)}</span>
                    <span className={getStatusBadge(quotation.status)} style={{marginLeft: '8px'}}>
                      {quotation.status || 'PENDING'}
                    </span>
                  </div>
                  <span className={dc.gridCardAmount}>₹{addCommas(quotation.totalAmount)}</span>
                </div>
                <div className="mb-2">
                  <div className={dc.gridCardRecipient}>
                    {quotation.recipientType === 'Customer' 
                      ? quotation.recipient?.name 
                      : quotation.recipient?.businessName}
                  </div>
                  <span className={dc.gridCardSub}>{quotation.recipientType}</span>
                </div>
                <div className="mb-2">
                  <span className={dc.gridCardLabel}>Sales Team: </span>
                  <span className={dc.gridCardSub}>
                    {quotation.salesmen.map(s => s.name).join(', ') || 'None'}
                  </span>
                </div>
                <div className="mb-3">
                  {quotationStatuses[quotation._id] ? (
                    <div className="flex items-center gap-2 text-xs">
                      <span className={dc.gridCardLabel}>Reminders:</span>
                      <span className="inline-flex items-center gap-1">
                        <span className="w-2 h-2 rounded-full bg-green-500 inline-block"></span>
                        <span className={dc.gridCardSub}>{quotationStatuses[quotation._id].completed} Done</span>
                      </span>
                      {quotationStatuses[quotation._id].partialComplete > 0 && (
                        <span className="inline-flex items-center gap-1">
                          <span className="w-2 h-2 rounded-full bg-yellow-500 inline-block"></span>
                          <span className={dc.gridCardSub}>{quotationStatuses[quotation._id].partialComplete} Partial</span>
                        </span>
                      )}
                      {quotationStatuses[quotation._id].pending > 0 && (
                        <span className="inline-flex items-center gap-1">
                          <span className="w-2 h-2 rounded-full bg-blue-500 inline-block"></span>
                          <span className={dc.gridCardSub}>{quotationStatuses[quotation._id].pending} Pending</span>
                        </span>
                      )}
                    </div>
                  ) : (
                    <span className={`text-xs ${dc.textMuted}`}>No Reminders</span>
                  )}
                </div>
                <div className="flex justify-between items-center pt-2 border-t border-gray-200 dark:border-gray-700">
                  <span className={dc.gridCardSub}>
                    {(() => { const d = new Date(quotation.createdAt); return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`; })()}
                  </span>
                  <div className="flex gap-2">
                    <button
                      onClick={(e) => { e.stopPropagation(); handleEdit(quotation._id); }}
                      className={dc.gridCardActionBtn}
                      title="Edit"
                    >
                      <FaEdit />
                    </button>
                    <button
                      onClick={(e) => { e.stopPropagation(); handleViewQuotation(quotation._id); }}
                      className={dc.gridCardActionBtn}
                      title="View Details"
                    >
                      <FaEye />
                    </button>
                    <button
                      onClick={(e) => { e.stopPropagation(); exportSingleQuotationToExcel(quotation); }}
                      className={dc.gridCardActionBtn}
                      title="Export Excel"
                    >
                      <FaFileDownload />
                    </button>
                    <button
                      onClick={(e) => { e.stopPropagation(); handleWhatsAppSend(quotation); }}
                      className={dc.gridCardActionBtn}
                      title="Send via WhatsApp"
                    >
                      <FaWhatsapp />
                    </button>
                    <Link
                      to={`/tally-quotation/${quotation._id}`}
                      target="_blank"
                      onClick={(e) => e.stopPropagation()}
                      className={dc.gridCardActionBtn}
                      title="Print"
                    >
                      <FaPrint />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className={dc.tableHead}><tr>
                <th className={`${dc.tableHeadTh} w-20`}>ID</th>
                <th className={`${dc.tableHeadTh} w-24`}>Status</th>
                <th className={`${dc.tableHeadTh} max-w-xs`}>Recipient</th>
                <th className={`${dc.tableHeadTh} w-32`}>Total Amount</th>
                <th className={`${dc.tableHeadTh} w-32`}>Sales Team</th>
                <th className={`${dc.tableHeadTh} w-32`}>Reminder Status</th>
                <th className={`${dc.tableHeadTh} w-24`}>Date</th>
                <th className={`${dc.tableHeadTh} text-right w-28`}>Actions</th>
              </tr></thead>
              <tbody className={`divide-y divide-gray-200 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
                {quotations.map((quotation, index) => (
                    <tr 
                      key={quotation._id} 
                      className={index % 2 === 0 ? dc.tableRow : dc.tableRowAlt}
                      onClick={(e) => {
                        if (e.target === e.currentTarget || e.target.tagName !== 'BUTTON') {
                          handleViewQuotation(quotation._id);
                        }
                      }}
                    >
                      <td className={`${dc.tableTdBold} w-20`}>
                        {safeDisplay(quotation.id)}
                      </td>
                      <td className={`${dc.tableTd} w-24`}>
                        <span className={getStatusBadge(quotation.status)}>
                          {quotation.status || 'PENDING'}
                        </span>
                      </td>
                      <td className={`${dc.tableTd} max-w-xs`}>
                        <div className="truncate" title={quotation.recipientType === 'Customer' 
                          ? quotation.recipient?.name 
                          : quotation.recipient?.businessName
                        }>
                          {quotation.recipientType === 'Customer' 
                            ? quotation.recipient?.name 
                            : quotation.recipient?.businessName
                          }
                        </div>
                        <span className={`text-xs block ${dc.textMuted}`}>
                          {quotation.recipientType}
                        </span>
                      </td>
                      <td className={`${dc.tableTd} font-medium text-green-600 w-32`}>
                        ₹{addCommas(quotation.totalAmount)}
                      </td>
                      <td className={`${dc.tableTd} w-32`}>
                        {quotation.salesmen.map((salesman) => (
                          <div key={salesman._id}>
                            <span>{salesman.name}</span>
                          </div>
                        ))}
                      </td>
                      <td className={`${dc.tableTd} w-32`}>
                        {quotationStatuses[quotation._id] ? (
                          <div className="text-xs">
                            <div className="flex items-center gap-1">
                              <span className="font-semibold">
                                {quotationStatuses[quotation._id].completed}/{quotationStatuses[quotation._id].total}
                              </span>
                              <span className={dc.textMuted}>Completed</span>
                            </div>
                            {quotationStatuses[quotation._id].partialComplete > 0 && (
                              <div className="text-yellow-600">
                                {quotationStatuses[quotation._id].partialComplete} Partial
                              </div>
                            )}
                            {quotationStatuses[quotation._id].pending > 0 && (
                              <div className="text-blue-600">
                                {quotationStatuses[quotation._id].pending} Pending
                              </div>
                            )}
                          </div>
                        ) : (
                          <span className={`text-xs ${dc.textMuted}`}>No Reminders</span>
                        )}
                      </td>
                      <td className={`${dc.tableTd} w-24`}>
                        {(() => { const d = new Date(quotation.createdAt); return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`; })()}
                      </td>
                      <td className={`${dc.tableTd} text-right font-medium w-28`}>
                        <div className="flex justify-end space-x-3">
                          <button
                            onClick={(e) => { e.stopPropagation(); handleEdit(quotation._id); }}
                            className="text-blue-500 hover:text-blue-700 p-1"
                            title="Edit"
                          >
                            <FaEdit />
                          </button>
                          <button
                            onClick={(e) => { e.stopPropagation(); handleViewQuotation(quotation._id); }}
                            className="text-gray-500 hover:text-gray-700 p-1"
                            title="View Details"
                          >
                            <FaEye />
                          </button>
                          <button
                            onClick={(e) => { e.stopPropagation(); exportSingleQuotationToExcel(quotation); }}
                            className="text-purple-500 hover:text-purple-700 p-1"
                            title="Export Excel"
                          >
                            <FaFileDownload />
                          </button>
                          <button
                            onClick={(e) => { e.stopPropagation(); handleWhatsAppSend(quotation); }}
                            className="text-green-500 hover:text-green-700 p-1"
                            title="Send via WhatsApp"
                          >
                            <FaWhatsapp />
                          </button>
                          <Link
                            to={`/tally-quotation/${quotation._id}`}
                            target="_blank"
                            onClick={(e) => e.stopPropagation()}
                            className="text-green-500 hover:text-green-700 p-1"
                            title="Print"
                          >
                            <FaPrint />
                          </Link>
                        </div>
                      </td>
                    </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div className="flex justify-between items-center mt-4">
          <div className="flex items-center gap-4">
            <button
              onClick={() => setQuotationPage(Math.max(1, quotationPage - 1))}
              disabled={quotationPage === 1}
              className={dc.paginationBtn}
            >
              <FaAngleLeft className="mr-1" />
              Previous
            </button>
            <span className={dc.paginationText}>
              Page {quotationPage} of {Math.ceil(totalQuotations / quotationLimit)}
            </span>
            <button
              onClick={() => setQuotationPage(Math.min(Math.ceil(totalQuotations / quotationLimit), quotationPage + 1))}
              disabled={quotationPage >= Math.ceil(totalQuotations / quotationLimit)}
              className={dc.paginationBtn}
            >
              Next
              <FaAngleRight className="ml-1" />
            </button>
          </div>
          <select
            value={quotationLimit}
            onChange={(e) => {
              setQuotationLimit(Number(e.target.value));
              setQuotationPage(1); // Reset to first page when changing limit
            }}
            className={dc.paginationSelect}
          >
            <option value={5}>5 per page</option>
            <option value={10}>10 per page</option>
            <option value={20}>20 per page</option>
            <option value={50}>50 per page</option>
          </select>
        </div>
      </div>
      {showDetailsModal && selectedQuotation && (
        <div className={dc.modalOverlay}>
          <div className={`${dc.modalCard} ${isDarkMode ? 'tq-modal-dark' : ''}`}>
            {/* Header */}
            <div className={dc.modalHeader}>
              <div className="flex items-center space-x-4">
                <div className="bg-white bg-opacity-20 p-2 rounded-lg">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-xl font-bold text-white">Quotation {formatId(selectedQuotation?.id)}</h2>
                  <p className="text-xs text-blue-100 opacity-80">Created on {(() => { const d = new Date(selectedQuotation.createdAt); return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`; })()}</p>
                </div>
              </div>
              <button 
                onClick={() => setShowDetailsModal(false)}
                className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition-colors"
                aria-label="Close dialog"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Content - Scrollable */}
            <div className="overflow-y-auto flex-grow">
              {/* Status Bar */}
              <div className={dc.modalStatusBar}>
                <div className="flex items-center space-x-4">
                  <span className="bg-green-100 text-green-800 text-xs font-semibold px-2.5 py-0.5 rounded-full flex items-center">
                    <span className="w-2 h-2 bg-green-500 rounded-full mr-1"></span>
                    Active
                  </span>
                  <span className="text-gray-500 text-sm">
                    Total Items: {selectedQuotation.sections.reduce((acc, section) => acc + section.items.length, 0)}
                  </span>
                </div>
                <div className="text-sm font-medium text-gray-900">
                  Prepared by: {selectedQuotation.createdBy?.name || 'Unknown'}
                </div>
              </div>

              <div className="p-6 space-y-8">
                {/* Overview Cards */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {/* Recipient Card */}
                  <div className={`rounded-lg border shadow-sm overflow-hidden ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                    <div className={`px-4 py-3 border-b ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'}`}>
                      <h3 className="text-sm font-medium text-gray-700 uppercase tracking-wide flex items-center">
                        <svg className="w-4 h-4 mr-1 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                        </svg>
                        Recipient
                      </h3>
                    </div>
                    <div className="p-4">
                      <div className="mb-3 pb-3 border-b border-gray-100">
                        <div className="text-xs text-gray-500 mb-1">Type</div>
                        <div className="font-medium">{selectedQuotation.recipientType}</div>
                      </div>
                      <div>
                        <div className="text-xs text-gray-500 mb-1">Name</div>
                        <div className="font-medium">
                          {selectedQuotation.recipientType === 'Customer' 
                            ? selectedQuotation.recipient?.name 
                            : selectedQuotation.recipient?.businessName}
                        </div>
                        {selectedQuotation.recipient?.phone && (
                          <div className="text-sm text-gray-500 mt-1">
                            {selectedQuotation.recipient?.phone}
                          </div>
                        )}
                      </div>
                      {selectedQuotation.siteAddress && (
                        <div className="mt-3 pt-3 border-t border-gray-100">
                          <div className="text-xs text-gray-500 mb-1">Site Address</div>
                          <div className="font-medium text-gray-800 whitespace-pre-line">
                            {selectedQuotation.siteAddress}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  {/* Amount Card */}
                  <div className={`rounded-lg border shadow-sm overflow-hidden ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                    <div className={`px-4 py-3 border-b ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'}`}>
                      <h3 className="text-sm font-medium text-gray-700 uppercase tracking-wide flex items-center">
                        <svg className="w-4 h-4 mr-1 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                        Amount Details
                      </h3>
                    </div>
                    <div className="p-4 space-y-3">
                      <div className="flex justify-between items-center">
                        <div className="text-sm text-gray-500">Listed Price:</div>
                        <div className="font-medium">₹{formatNumberWithCommas(selectedQuotation.listedPriceGrandTotal || 0)}</div>
                      </div>
                      <div className="flex justify-between items-center">
                        <div className="text-sm text-gray-500">Offer Price:</div>
                        <div className="font-medium text-purple-700">₹{formatNumberWithCommas(selectedQuotation.offerPriceGrandTotal || 0)}</div>
                      </div>
                      <div className="flex justify-between items-center pt-2 border-t border-gray-100">
                        <div className="text-sm font-medium">Total Amount:</div>
                        <div className="text-lg font-bold text-green-700">₹{formatNumberWithCommas(selectedQuotation.totalAmount || 0)}</div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Salesmen Card */}
                  <div className={`rounded-lg border shadow-sm overflow-hidden ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                    <div className={`px-4 py-3 border-b ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'}`}>
                      <h3 className="text-sm font-medium text-gray-700 uppercase tracking-wide flex items-center">
                        <svg className="w-4 h-4 mr-1 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                        </svg>
                        Team
                      </h3>
                    </div>
                    <div className="p-4">
                      <div className="space-y-3">
                        <div>
                          <div className="text-xs text-gray-500 mb-1">Salesmen</div>
                          {selectedQuotation.salesmen && selectedQuotation.salesmen.length > 0 ? (
                            <div className="flex flex-wrap gap-2">
                              {selectedQuotation.salesmen.map((salesman) => (
                                <div key={salesman._id} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                  {salesman.name}
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="text-sm italic text-gray-500">No salesmen assigned</div>
                          )}
                        </div>
                        
                        <div>
                          <div className="text-xs text-gray-500 mb-1">Reference</div>
                          <div className="font-medium">
                            {selectedQuotation.reference?.name || 'Not specified'}
                          </div>
                        </div>
                        
                        <div>
                          <div className="text-xs text-gray-500 mb-1">Transporter</div>
                          <div className="font-medium">
                            {selectedQuotation.transporterName?.name || 'Not specified'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Additional Charges */}
                <div className={`rounded-lg border shadow-sm overflow-hidden ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                  <div className={`px-4 py-3 border-b ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'}`}>
                    <h3 className="text-sm font-medium text-gray-700 uppercase tracking-wide flex items-center">
                      <svg className="w-4 h-4 mr-1 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                      </svg>
                      Additional Charges
                    </h3>
                  </div>
                  
                  <div className="p-4">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                      <div className={`rounded p-3 ${isDarkMode ? 'bg-gray-700' : 'bg-gray-50'}`}>
                        <div className="text-xs text-gray-500 mb-1">Cartage</div>
                        <div className="font-medium">₹{formatNumberWithCommas(selectedQuotation.cartage || 0)}</div>
                        <div className="text-xs text-gray-500 mt-1">+GST: ₹{formatNumberWithCommas((selectedQuotation.cartage || 0) * 0.18)}</div>
                      </div>
                      
                      <div className={`rounded p-3 ${isDarkMode ? 'bg-gray-700' : 'bg-gray-50'}`}>
                        <div className="text-xs text-gray-500 mb-1">Packing & Forwarding</div>
                        <div className="font-medium">₹{formatNumberWithCommas(selectedQuotation.packingAndForwarding || 0)}</div>
                        <div className="text-xs text-gray-500 mt-1">+GST: ₹{formatNumberWithCommas((selectedQuotation.packingAndForwarding || 0) * 0.18)}</div>
                      </div>
                      
                      <div className={`rounded p-3 ${isDarkMode ? 'bg-gray-700' : 'bg-gray-50'}`}>
                        <div className="text-xs text-gray-500 mb-1">Labour</div>
                        <div className="font-medium">₹{formatNumberWithCommas(selectedQuotation.labour || 0)}</div>
                        <div className="text-xs text-gray-500 mt-1">+GST: ₹{formatNumberWithCommas((selectedQuotation.labour || 0) * 0.18)}</div>
                      </div>
                      
                      <div className={`rounded p-3 ${isDarkMode ? 'bg-gray-700' : 'bg-gray-50'}`}>
                        <div className="text-xs text-gray-500 mb-1">Round Off</div>
                        <div className="font-medium">₹{formatNumberWithCommas(selectedQuotation.roundOff || 0)}</div>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Remarks */}
                {selectedQuotation.remarks && (
                  <div className={`rounded-lg p-4 border ${isDarkMode ? 'bg-yellow-900/20 border-yellow-700' : 'bg-yellow-50 border-yellow-200'}`}>
                    <h3 className={`text-sm font-semibold flex items-center mb-2 ${isDarkMode ? 'text-yellow-300' : 'text-yellow-800'}`}>
                      <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                      </svg>
                      Remarks
                    </h3>
                    <p className={`text-sm ${isDarkMode ? 'text-yellow-300' : 'text-yellow-800'}`}>{selectedQuotation.remarks}</p>
                  </div>
                )}

                {/* Sections */}
                <div className="space-y-6">
                  <h3 className="text-lg font-semibold text-gray-900 border-b pb-2">Quotation Items</h3>
                  
                  <div className="space-y-6">
                    {selectedQuotation.sections.map((section, sectionIndex) => (
                      <div key={sectionIndex} className={`rounded-lg overflow-hidden shadow-sm border ${isDarkMode ? 'bg-gray-900 border-gray-700' : 'bg-white border-gray-200'}`}>
                        <div className={`px-4 py-3 border-b flex justify-between items-center ${isDarkMode ? 'bg-gray-800 border-gray-600' : 'bg-gradient-to-r from-gray-50 to-gray-100 border-gray-200'}`}>
                          <h4 className={`font-medium text-sm md:text-base ${isDarkMode ? 'text-gray-200' : 'text-gray-800'}`}>
                            Section {sectionIndex + 1}: {section.name || 'Untitled Section'}
                          </h4>
                          <span className={isDarkMode ? 'text-green-300 font-semibold' : 'text-blue-700 font-medium'}>
                            ₹{formatNumberWithCommas(section.offerPriceTotal || 0)}
                          </span>
                        </div>
                        
                        <div className="overflow-x-auto">
                          <table className={`min-w-full divide-y ${isDarkMode ? 'divide-gray-700' : 'divide-gray-200'}`}> 
                            <thead className={isDarkMode ? 'bg-gray-800' : 'bg-gray-50'}>
                              <tr>
                                <th scope="col" className={`px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider ${isDarkMode ? 'text-gray-300 bg-gray-800' : 'text-gray-500 bg-gray-50'}`}>ITEM</th>
                                <th scope="col" className={`px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider ${isDarkMode ? 'text-gray-300 bg-gray-800' : 'text-gray-500 bg-gray-50'}`}>PRINT NAME</th>
                                <th scope="col" className={`px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider ${isDarkMode ? 'text-gray-300 bg-gray-800' : 'text-gray-500 bg-gray-50'}`}>APPLICATION AREA</th>
                                <th scope="col" className={`px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider ${isDarkMode ? 'text-gray-300 bg-gray-800' : 'text-gray-500 bg-gray-50'}`}>QUANTITY</th>
                                <th scope="col" className={`px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider ${isDarkMode ? 'text-gray-300 bg-gray-800' : 'text-gray-500 bg-gray-50'}`}>LISTED PRICE</th>
                                <th scope="col" className={`px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider ${isDarkMode ? 'text-gray-300 bg-gray-800' : 'text-gray-500 bg-gray-50'}`}>DISCOUNT</th>
                                <th scope="col" className={`px-4 py-3 text-right text-xs font-semibold uppercase tracking-wider ${isDarkMode ? 'text-gray-300 bg-gray-800' : 'text-gray-500 bg-gray-50'}`}>TOTAL</th>
                              </tr>
                            </thead>
                            <tbody className={`divide-y ${isDarkMode ? 'bg-gray-800 divide-gray-700' : 'bg-white divide-gray-100'}`}>
                              {section.items.map((item, itemIndex) => (
                                <tr key={itemIndex} className={isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}>
                                  <td className="px-4 py-3">
                                    <div className="font-medium text-gray-900 text-sm">{item.itemName || item.customName}</div>
                                    {item.item?.Name && item.itemName !== item.item.Name && (
                                      <div className="text-xs text-gray-500 mt-1">{item.item.Name}</div>
                                    )}
                                  </td>
                                  <td className="px-4 py-3 text-sm text-gray-500">
                                    {item.customName || '-'}
                                  </td>
                                  <td className="px-4 py-3 text-sm text-gray-500">
                                    {item.applicationArea || '-'}
                                  </td>
                                  <td className="px-4 py-3">
                                    {(item.parameter?.calculationType === 'pcsPerBox' || item.item?.parameter?.calculationType === 'pcsPerBox') ? (
                                      <div className="text-sm text-gray-900">
                                        <span className="font-medium">{item.boxes}</span> Box, <span className="font-medium">{item.pieces}</span> Pcs
                                        {item.coverageArea > 0 && (
                                          <div className="text-xs text-gray-500 mt-1">
                                            Coverage: {item.coverageArea} {item.coverageAreaUnit || 'sqft'}
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="text-sm text-gray-900">
                                        {item.quantity} {item.unit || 'pcs'}
                                      </div>
                                    )}
                                  </td>
                                  <td className="px-4 py-3 text-sm text-gray-900">
                                    ₹{formatNumberWithCommas(item.listedPrice)}
                                  </td>
                                  <td className="px-4 py-3">
                                    {item.discount > 0 ? (
                                      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                        {item.discount}%
                                      </span>
                                    ) : (
                                      <span className="text-sm text-gray-400">-</span>
                                    )}
                                  </td>
                                  <td className="px-4 py-3 text-right">
                                    <div className="text-sm font-medium text-gray-900">
                                      ₹{formatNumberWithCommas(item.offerPriceTotal)}
                                    </div>
                                    {item.discount > 0 && (
                                      <div className="text-xs text-gray-500 line-through">
                                        ₹{formatNumberWithCommas(item.listedPriceTotal)}
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                            <tfoot className={isDarkMode ? 'bg-gray-700' : 'bg-gray-50'}>
                              <tr>
                                <td colSpan="6" className="px-4 py-3 text-sm font-medium text-gray-700 text-right">
                                  Section Total:
                                </td>
                                <td className="px-4 py-3 text-right">
                                  <div className="font-bold text-blue-700">
                                    ₹{formatNumberWithCommas(section.offerPriceTotal)}
                                  </div>
                                  {section.offerPriceTotal !== section.listedPriceTotal && (
                                    <div className="text-xs text-gray-500 line-through">
                                      ₹{formatNumberWithCommas(section.listedPriceTotal)}
                                    </div>
                                  )}
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  {/* Summary */}
                  <div className={`rounded-lg p-4 border ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-100'}`}>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="space-y-1">
                        <div className="text-xs text-gray-500">Items</div>
                        <div className="text-xl font-semibold text-gray-800">
                          {selectedQuotation.sections.reduce((total, section) => total + section.items.length, 0)}
                        </div>
                      </div>
                      <div className="space-y-1">
                        <div className="text-xs text-gray-500">Sections</div>
                        <div className="text-xl font-semibold text-gray-800">
                          {selectedQuotation.sections.length}
                        </div>
                      </div>
                      <div className="space-y-1">
                        <div className="text-xs text-gray-500">Grand Total</div>
                        <div className="text-xl font-bold text-green-700">
                          ₹{formatNumberWithCommas(selectedQuotation.totalAmount || 0)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className={`border-t p-4 flex justify-end gap-3 flex-shrink-0 rounded-b-xl ${isDarkMode ? 'border-gray-700 bg-gray-800' : 'border-gray-200 bg-gray-50'}`}>
              <button
                onClick={() => setShowDetailsModal(false)}
                className={`px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 flex items-center transition-colors shadow-sm ${isDarkMode ? 'border-gray-600 text-gray-300 bg-gray-700 hover:bg-gray-600' : 'border-gray-300 text-gray-700 bg-white hover:bg-gray-50'}`}
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                Close
              </button>
              <button
                onClick={() => { handleEdit(selectedQuotation._id); setShowDetailsModal(false); }}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 flex items-center transition-colors shadow-sm"
              >
                <FaEdit className="mr-2" />
                Edit Quotation
              </button>
              <button
                onClick={() => exportSingleQuotationToExcel(selectedQuotation)}
                className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 flex items-center transition-colors shadow-sm"
              >
                <FaFileDownload className="mr-2" />
                Export Excel
              </button>
              <Link
                to={`/tally-quotation/${selectedQuotation._id}`}
                target="_blank"
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 flex items-center transition-colors shadow-sm"
              >
                <FaPrint className="mr-2" />
                Print Quotation
              </Link>
            </div>
          </div>
        </div>
      )}
      {/* Item Selection Modal */}
      {modalVisible.open && (
        <div className={dc.modalOverlay}>
          <div className={`bg-white rounded-xl w-full max-w-6xl flex flex-col max-h-[95vh] shadow-2xl animate-fadeIn ${isDarkMode ? 'tq-modal-dark' : ''}`}>
            <div className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 px-6 py-5 flex justify-between items-center rounded-t-xl">
              <div>
                <h3 className="text-xl font-bold text-white flex items-center gap-2">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                  Select Item
                </h3>
                <p className="text-blue-100 text-sm mt-1">Choose an item to add to your quotation</p>
              </div>
              <button
                onClick={() => setModalVisible({ open: false, func: null })}
                className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition-all duration-200 hover:scale-110"
                aria-label="Close dialog"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className={`p-6 border-b ${isDarkMode ? 'border-gray-700 bg-gradient-to-r from-gray-800 to-gray-700' : 'border-gray-200 bg-gradient-to-r from-gray-50 to-blue-50'}`}>
              <div className="relative">
                <input
                  ref={inputRef}
                  type="text"
                  className={`w-full p-4 pl-12 pr-4 border-2 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 shadow-sm ${isDarkMode ? 'border-gray-600 bg-gray-700 text-gray-100 placeholder-gray-400' : 'border-gray-300 text-gray-700 placeholder-gray-500'}`}
                  placeholder="Search for items by name, category, or HSN code..."
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                />
                <svg className="absolute left-4 top-4 w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                {filter && (
                  <button
                    onClick={() => setFilter('')}
                    className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 transition-colors"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </div>
              {total > 0 && (
                <div className="mt-3 text-sm text-gray-600 bg-blue-100 px-4 py-2 rounded-lg">
                  <span className="font-semibold">{total}</span> items found
                  {filter && <span> matching "{filter}"</span>}
                  {filteredItems.length > 0 && total > limit && (
                    <span className="ml-2 text-gray-500">
                      (showing {filteredItems.length} on this page)
                    </span>
                  )}
                </div>
              )}
            </div>

            <div className="overflow-y-auto flex-grow max-h-[60vh]">
              {filteredItems.length > 0 ? (
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gradient-to-r from-gray-50 to-gray-100 sticky top-0 z-10 shadow-sm">
                      <tr>
                        <th className="px-6 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-200">
                          <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a1.994 1.994 0 01-1.414.586H7a4 4 0 01-4-4V7a4 4 0 014-4z" />
                            </svg>
                            Name
                          </div>
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-200">
                          <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                            </svg>
                            Type
                          </div>
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-200">
                          <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                            </svg>
                            Integrated Tax
                          </div>
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-200">
                          <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                            </svg>
                            Net Available
                          </div>
                        </th>
                        <th className="px-6 py-4 text-right text-xs font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-200">
                          <div className="flex items-center justify-end gap-2">
                            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4" />
                            </svg>
                            Actions
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-100">
                      {filteredItems.map((item, index) => (
                        <tr key={item._id} className={`transition-all duration-200 hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 hover:shadow-sm ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
                          <td className="px-6 py-4">
                            <div className="flex flex-col">
                              <div className="text-sm font-semibold text-gray-900 mb-1">{item.Name}</div>
                              {item.category && (
                                <div className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full inline-block w-fit">
                                  {item.category}
                                </div>
                              )}
                            </div>
                          </td>
                          <td className="px-6 py-4">
                            <div className="flex items-center">
                              {item.parameter?.calculationType === 'pcsPerBox' ? (
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                                  <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                  </svg>
                                  Box ({item.parameter.piecesPerBox} pcs/box)
                                </span>
                              ) : (
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                  <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a1.994 1.994 0 01-1.414.586H7a4 4 0 01-4-4V7a4 4 0 014-4z" />
                                  </svg>
                                  Regular
                                </span>
                              )}
                            </div>
                          </td>
                          <td className="px-6 py-4">
                            <div className="flex items-center">
                              {item.integratedTax ? (
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                  <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                                  </svg>
                                  {item.integratedTax}%
                                </span>
                              ) : (
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                                  N/A
                                </span>
                              )}
                            </div>
                          </td>
                          <td className="px-6 py-4">
                            {item.reorderStatus?.netAvailable ? (
                              <div className="flex flex-col">
                                <span className={`text-sm font-bold ${item.reorderStatus.netAvailable.base > 0 ? 'text-emerald-700' : 'text-red-600'}`}>
                                  {item.reorderStatus.netAvailable.base} {item.reorderStatus.netAvailable.unit || item.baseUnits}
                                </span>
                                {item.reorderStatus.netAvailable.additional > 0 && (
                                  <span className="text-xs text-blue-600">+{item.reorderStatus.netAvailable.additional} {item.additionalUnits || 'PCS'}</span>
                                )}
                              </div>
                            ) : item.closingBalance ? (
                              <span className={`text-sm font-bold ${parseFloat(item.closingBalance) > 0 ? 'text-emerald-700' : 'text-red-600'}`}>
                                {item.closingBalance} {item.baseUnits}
                              </span>
                            ) : (
                              <span className="text-xs text-gray-400 italic">N/A</span>
                            )}
                          </td>
                          <td className="px-6 py-4">
                            <div className="flex items-center gap-3 justify-end">
                              <button
                                onClick={() => handleViewItemDetails(item)}
                                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-indigo-700 bg-indigo-50 border border-indigo-200 rounded-lg hover:bg-indigo-100 hover:border-indigo-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1 transition-all duration-200"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                                View Details
                              </button>
                              <button
                                onClick={() => {
                                  if (modalVisible.func) {
                                    modalVisible.func(item);
                                  }
                                  setModalVisible({ open: false, func: null });
                                }}
                                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-blue-700 border border-transparent rounded-lg hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 transition-all duration-200 shadow-sm hover:shadow-md"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                                Select
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center p-8">
                  <svg className="w-12 h-12 text-gray-300 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <p className="text-gray-500 text-lg">No items found</p>
                  <p className="text-gray-400 text-sm mt-1">Try adjusting your search</p>
                </div>
              )}
            </div>

            <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 flex items-center justify-between rounded-b-xl border-t border-gray-200">
              <div className="flex items-center gap-3">
                <button
                  onClick={() => setPage(Math.max(1, page - 1))}
                  disabled={page === 1}
                  className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                  </svg>
                  Previous
                </button>
                <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg border border-gray-300">
                  <span className="text-sm font-medium text-gray-700">
                    Page <span className="text-blue-600 font-bold">{page}</span> of <span className="text-blue-600 font-bold">{Math.ceil(total / limit)}</span>
                  </span>
                  <div className="w-px h-4 bg-gray-300 mx-2"></div>
                  <span className="text-sm text-gray-500">
                    Showing <span className="font-medium">{((page - 1) * limit) + 1}</span>-<span className="font-medium">{Math.min(page * limit, total)}</span> of <span className="font-medium">{total}</span>
                  </span>
                </div>
                <button
                  onClick={() => setPage(Math.min(Math.ceil(total / limit), page + 1))}
                  disabled={page >= Math.ceil(total / limit)}
                  className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                >
                  Next
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
              <div className="flex items-center gap-2">
                <label className="text-sm font-medium text-gray-700">Items per page:</label>
                <select
                  value={limit}
                  onChange={(e) => {
                    setLimit(parseInt(e.target.value));
                    setPage(1);
                  }}
                  className="px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Item Details Modal */}
      {showItemDetailsModal && selectedItemForDetails && (
        <div className={dc.modalOverlay}>
          <div className={`bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[80vh] overflow-y-auto ${isDarkMode ? 'tq-modal-dark' : ''}`}>
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
              <h3 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                <FaEye className="text-indigo-600" />
                Item Details - {selectedItemForDetails.Name}
              </h3>
              <button
                onClick={() => {
                  setShowItemDetailsModal(false);
                  setSelectedItemForDetails(null);
                }}
                className="text-gray-400 hover:text-gray-600 p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <FaTimes size={20} />
              </button>
            </div>
            <div className="p-6 space-y-6">
              {/* Basic Information */}
              <div className="border-b border-gray-200 pb-4">
                <h4 className="text-lg font-semibold text-gray-700 mb-3">Basic Information</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">ID:</span>
                    <div className="font-medium text-indigo-600 bg-indigo-50 px-2 py-1 rounded text-sm">{selectedItemForDetails.id}</div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">GUID:</span>
                    <div className="font-mono text-xs text-gray-600 bg-gray-50 px-2 py-1 rounded">{selectedItemForDetails.GUID}</div>
                  </div>
                  <div className="col-span-full">
                    <span className="text-sm text-gray-500">Name:</span>
                    <div className="font-medium text-gray-900 mt-1 p-2 bg-gray-50 rounded">{selectedItemForDetails.Name}</div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Category:</span>
                    <div className="font-medium bg-blue-50 text-blue-800 px-2 py-1 rounded text-sm">{selectedItemForDetails.category}</div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Parent:</span>
                    <div className="font-medium text-gray-700">{selectedItemForDetails.parent || 'None'}</div>
                  </div>
                </div>
              </div>

              {/* Tax Information */}
              <div className="border-b border-gray-200 pb-4">
                <h4 className="text-lg font-semibold text-gray-700 mb-3">Tax Information</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">HSN Code:</span>
                    <div className="font-medium bg-yellow-50 text-yellow-800 px-2 py-1 rounded text-sm">{selectedItemForDetails.hsnCode}</div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">GST Applicable:</span>
                    <div className={`font-medium px-2 py-1 rounded text-sm ${
                      selectedItemForDetails.gstApplicable === 'Yes' 
                        ? 'bg-green-50 text-green-800' 
                        : 'bg-red-50 text-red-800'
                    }`}>
                      {selectedItemForDetails.gstApplicable}
                    </div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Integrated Tax:</span>
                    <div className="font-medium text-gray-700">{selectedItemForDetails.integratedTax}%</div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Central Tax:</span>
                    <div className="font-medium text-gray-700">{selectedItemForDetails.centralTax}%</div>
                  </div>
                </div>
              </div>

              {/* Units Information */}
              <div className="border-b border-gray-200 pb-4">
                <h4 className="text-lg font-semibold text-gray-700 mb-3">Units Information</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Base Units:</span>
                    <div className="font-medium bg-purple-50 text-purple-800 px-2 py-1 rounded text-sm">{selectedItemForDetails.baseUnits}</div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Additional Units:</span>
                    <div className="font-medium text-gray-700">{selectedItemForDetails.additionalUnits || 'None'}</div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Closing Balance:</span>
                    <div className="font-medium text-gray-700">{selectedItemForDetails.closingBalance}</div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Net Available:</span>
                    {selectedItemForDetails.reorderStatus?.netAvailable ? (
                      <div className="flex items-center gap-2">
                        <span className={`font-bold px-2 py-1 rounded text-sm ${selectedItemForDetails.reorderStatus.netAvailable.base > 0 ? 'bg-emerald-50 text-emerald-700' : 'bg-red-50 text-red-600'}`}>
                          {selectedItemForDetails.reorderStatus.netAvailable.base} {selectedItemForDetails.reorderStatus.netAvailable.unit || selectedItemForDetails.baseUnits}
                        </span>
                        {selectedItemForDetails.reorderStatus.netAvailable.additional > 0 && (
                          <span className="text-xs font-medium text-blue-600 bg-blue-50 px-2 py-1 rounded">
                            +{selectedItemForDetails.reorderStatus.netAvailable.additional} {selectedItemForDetails.additionalUnits || 'PCS'}
                          </span>
                        )}
                      </div>
                    ) : (
                      <div className="font-medium text-gray-400 italic text-sm">N/A</div>
                    )}
                  </div>
                </div>
              </div>

              {/* Product Information */}
              <div className="border-b border-gray-200 pb-4">
                <h4 className="text-lg font-semibold text-gray-700 mb-3">Product Information</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Part Number:</span>
                    <div className="font-medium text-gray-700 font-mono text-sm">{selectedItemForDetails.partNo || 'Not specified'}</div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Alter ID:</span>
                    <div className="font-medium text-gray-700">{selectedItemForDetails.alterID}</div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Section:</span>
                    <div className="font-medium text-gray-700">{selectedItemForDetails.section || 'Not assigned'}</div>
                  </div>
                  <div className="col-span-full">
                    <span className="text-sm text-gray-500">Remote Alt GUID:</span>
                    <div className="font-mono text-xs text-gray-600 bg-gray-50 px-2 py-1 rounded mt-1 break-all">
                      {selectedItemForDetails.remoteAltGUID}
                    </div>
                  </div>
                </div>
              </div>

              {/* Assignments */}
              <div className="border-b border-gray-200 pb-4">
                <h4 className="text-lg font-semibold text-gray-700 mb-3">Assignments</h4>
                <div className="grid grid-cols-1 gap-4">
                  <div>
                    <span className="text-sm text-gray-500">Parameter:</span>
                    {selectedItemForDetails.parameter ? (
                      <div className="mt-1 p-3 bg-green-50 border border-green-200 rounded">
                        <div className="font-medium text-green-800">{selectedItemForDetails.parameter.name}</div>
                        <div className="text-xs text-green-600">
                          Type: {selectedItemForDetails.parameter.calculationType === 'pcsPerBox' ? 'Pieces per Box' : 'Simple Pieces'}
                        </div>
                        {selectedItemForDetails.parameter.calculationType === 'pcsPerBox' && (
                          <div className="text-xs text-green-600 mt-1">
                            Size: {selectedItemForDetails.parameter.width}×{selectedItemForDetails.parameter.height} | 
                            Box: {selectedItemForDetails.parameter.piecesPerBox} pcs | 
                            Coverage: {selectedItemForDetails.parameter.coverageArea} {selectedItemForDetails.parameter.coverageAreaUnit}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="mt-1 p-3 bg-gray-50 border border-gray-200 rounded text-gray-500 text-sm">
                        No parameter assigned
                      </div>
                    )}
                  </div>
                  <div>
                    <span className="text-sm text-gray-500">Brand:</span>
                    {selectedItemForDetails.brand ? (
                      <div className="mt-1 p-3 bg-blue-50 border border-blue-200 rounded">
                        <div className="font-medium text-blue-800">{selectedItemForDetails.brand.name}</div>
                      </div>
                    ) : (
                      <div className="mt-1 p-3 bg-gray-50 border border-gray-200 rounded text-gray-500 text-sm">
                        No brand assigned
                      </div>
                    )}
                  </div>
                  <div>
                    <span className="text-sm text-gray-500">Series:</span>
                    <div className="mt-1 p-3 bg-purple-50 border border-purple-200 rounded">
                      <div className="font-medium text-purple-800">
                        {selectedItemForDetails.series || 'RS'} - {selectedItemForDetails.series === 'RS' ? 'Regular Stock (RS)' : selectedItemForDetails.series === 'AO' ? 'Against Order (AO)' : selectedItemForDetails.series === 'SC' ? 'Stock Clearance (SC)' : selectedItemForDetails.series === 'DC' ? 'Discontinued (DC)' : selectedItemForDetails.series === 'ITF' ? 'Item to Focus (ITF)' : selectedItemForDetails.series === 'OT' ? 'One Time (OT)' : 'Regular Stock (RS)'}
                      </div>
                    </div>
                  </div>
                  <div>
                    <span className="text-sm text-gray-500">Assigned Category:</span>
                    {selectedItemForDetails.assigncategory ? (
                      <div className="mt-1 p-3 bg-orange-50 border border-orange-200 rounded">
                        <div className="font-medium text-orange-800">{selectedItemForDetails.assigncategory.name}</div>
                      </div>
                    ) : (
                      <div className="mt-1 p-3 bg-gray-50 border border-gray-200 rounded text-gray-500 text-sm">
                        No assigned category
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Stock Information */}
              {selectedItemForDetails.stock && selectedItemForDetails.stock.length > 0 && (
                <div className="border-b border-gray-200 pb-4">
                  <h4 className="text-lg font-semibold text-gray-700 mb-3">Stock Information</h4>
                  <div className="space-y-2">
                    {selectedItemForDetails.stock.map((stockItem, index) => (
                      <div key={index} className="p-3 bg-gray-50 rounded border border-gray-200">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                          <div>
                            <span className="text-xs text-gray-500">Location:</span>
                            <div className="font-medium text-gray-700">{stockItem.location || 'Main Warehouse'}</div>
                          </div>
                          <div>
                            <span className="text-xs text-gray-500">Quantity:</span>
                            <div className="font-medium text-gray-700">{stockItem.quantity || 0} {selectedItemForDetails.baseUnits}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Price List Information */}
              {selectedItemForDetails.pricelist && selectedItemForDetails.pricelist.length > 0 && (
                <div className="border-b border-gray-200 pb-4">
                  <h4 className="text-lg font-semibold text-gray-700 mb-3 flex items-center gap-2">
                    <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    Price List
                  </h4>
                  <div className="space-y-3">
                    {selectedItemForDetails.pricelist.map((priceEntry, index) => (
                      <div key={index} className="p-4 bg-gradient-to-r from-green-50 to-blue-50 rounded-lg border border-green-200">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                          {priceEntry.date && (
                            <div>
                              <span className="text-xs text-gray-500 font-medium">Date:</span>
                              <div className="font-medium text-gray-700">
                                {(() => { const d = new Date(priceEntry.date); return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`; })() || priceEntry.date}
                              </div>
                            </div>
                          )}
                          {priceEntry.priceLevel && (
                            <div>
                              <span className="text-xs text-gray-500 font-medium">Price Level:</span>
                              <div className="font-medium text-blue-700 bg-blue-100 px-2 py-1 rounded text-sm">
                                {priceEntry.priceLevel}
                              </div>
                            </div>
                          )}
                          {priceEntry.rates && priceEntry.rates.length > 0 && (
                            <div>
                              <span className="text-xs text-gray-500 font-medium">Rates:</span>
                              <div className="space-y-1">
                                {priceEntry.rates.map((rateItem, rateIndex) => (
                                  <div key={rateIndex} className="font-bold text-green-700 bg-green-100 px-2 py-1 rounded text-sm">
                                    <div>₹{Math.ceil(rateItem.price || 0).toLocaleString('en-IN')}{rateItem.unit ? `/${rateItem.unit}` : ''} <span className="text-xs text-gray-600">(excl. GST)</span></div>
                                    <div className="text-green-800">₹{Math.ceil((rateItem.price || 0) + ((rateItem.price || 0) * 0.18)).toLocaleString('en-IN')}{rateItem.unit ? `/${rateItem.unit}` : ''} <span className="text-xs text-gray-600">(incl. 18% GST)</span></div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-2 text-xs text-gray-500 italic">
                    * Price list data synchronized from Tally ERP
                  </div>
                </div>
              )}

              {/* Product Image */}
              {selectedItemForDetails.imageUrl && (
                <div className="border-b border-gray-200 pb-4">
                  <h4 className="text-lg font-semibold text-gray-700 mb-3">Product Image</h4>
                  <div className="flex justify-center">
                    <img
                      src={selectedItemForDetails.imageUrl}
                      alt={selectedItemForDetails.Name}
                      className="max-w-xs max-h-48 object-cover rounded-lg border border-gray-200"
                    />
                  </div>
                </div>
              )}

              {/* Action Buttons */}
              <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
                <button
                  onClick={() => {
                    if (modalVisible.func) {
                      modalVisible.func(selectedItemForDetails);
                    }
                    setModalVisible({ open: false, func: null });
                    setShowItemDetailsModal(false);
                    setSelectedItemForDetails(null);
                  }}
                  className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                >
                  Select This Item
                </button>
                <button
                  onClick={() => {
                    setShowItemDetailsModal(false);
                    setSelectedItemForDetails(null);
                  }}
                  className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Recipient Selection Modal */}
<MasterSelection
    isOpen={showRecipientModal}
    onClose={() => setShowRecipientModal(false)}
    onSelect={handleRecipientSelect}
    allowedTypes={['Customer', 'Dealer']}
    defaultType={form.recipientType}
        title="Select Recipient"
      />

      {/* Reference Selection Modal */}
      <MasterSelection
        isOpen={showReferenceModal}
        onClose={() => setShowReferenceModal(false)}
        onSelect={(item) => {
          setForm(prev => ({ ...prev, reference: item._id, referenceName: item.name }));
          setShowReferenceModal(false);
        }}
        allowedTypes={['Reference']}
        defaultType="Reference"
        title="Select Reference"
      />

      {/* Transporter Selection Modal */}
      <MasterSelection
        isOpen={showTransporterModal}
        onClose={() => setShowTransporterModal(false)}
        onSelect={(item) => {
          setForm(prev => ({ ...prev, transporterName: item._id, transporterDisplayName: item.name }));
          setShowTransporterModal(false);
        }}
        allowedTypes={['Transporter']}
        defaultType="Transporter"
        title="Select Transporter"
      />

      {/* Choice Import Modal */}
      {showChoiceImportModal && (
        <div className={dc.modalOverlay}>
          <div className={`bg-white rounded-xl shadow-xl max-w-5xl w-full max-h-[90vh] overflow-hidden ${isDarkMode ? 'tq-modal-dark' : ''}`}>
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 px-6 py-4">
              <div className="flex justify-between items-center">
                <div className="text-white">
                  <h2 className="text-xl font-bold flex items-center gap-2">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                    </svg>
                    Import Choices as Section
                  </h2>
                  <p className="text-blue-100 text-sm mt-1">Select choices to import their items into a new section</p>
                </div>
                <button
                  onClick={() => setShowChoiceImportModal(false)}
                  className="text-white hover:text-red-200 p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            <div className="flex flex-col h-[calc(90vh-120px)]">
              {/* Search and Section Name */}
              <div className="p-6 border-b border-gray-200 bg-gray-50">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Search Choices</label>
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Search choices..."
                        value={choiceSearch}
                        onChange={(e) => {
                          setChoiceSearch(e.target.value);
                          setChoicePage(1);
                          loadChoices(1, e.target.value);
                        }}
                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        style={{ textTransform: 'uppercase' }}
                      />
                      <svg className="absolute left-3 top-2.5 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Section Name</label>
                    <input
                      type="text"
                      value={importingSectionName}
                      onChange={(e) => setImportingSectionName(e.target.value)}
                      placeholder="Enter section name..."
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>
                {selectedChoices.length > 0 && (
                  <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                    <p className="text-sm text-blue-800">
                      <span className="font-semibold">{selectedChoices.length}</span> choice(s) selected for import
                    </p>
                  </div>
                )}
              </div>

              {/* Choice List */}
              <div className="flex-1 overflow-y-auto p-6">
                {loadingChoices ? (
                  <div className="flex justify-center items-center py-12">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                    <span className="ml-3 text-gray-600">Loading choices...</span>
                  </div>
                ) : choices.length === 0 ? (
                  <div className="text-center py-12">
                    <svg className="w-12 h-12 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <p className="text-gray-500 text-lg">No choices found</p>
                    <p className="text-gray-400 text-sm mt-1">Try adjusting your search criteria</p>
                  </div>
                ) : (
                  <div className="space-y-3">
                    {choices.map((choice) => {
                      const isSelected = selectedChoices.some(c => c._id === choice._id);
                      return (
                        <div
                          key={choice._id}
                          onClick={() => handleChoiceSelect(choice)}
                          className={`p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 ${
                            isSelected 
                              ? 'border-blue-500 bg-blue-50 shadow-md' 
                              : 'border-gray-200 bg-white hover:border-blue-300 hover:bg-blue-25'
                          }`}
                        >
                          <div className="flex items-start justify-between">
                            <div className="flex-1">
                              <div className="flex items-center gap-3 mb-2">
                                <div className={`w-5 h-5 rounded border-2 flex items-center justify-center ${
                                  isSelected ? 'bg-blue-600 border-blue-600' : 'border-gray-300'
                                }`}>
                                  {isSelected && (
                                    <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                                    </svg>
                                  )}
                                </div>
                                <div className="font-semibold text-gray-900">Choice {choice.id}</div>
                                <div className={`px-2 py-1 rounded-full text-xs font-medium ${
                                  choice.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
                                  choice.status === 'Send for quotation' ? 'bg-blue-100 text-blue-800' :
                                  choice.status === 'Send for billing' ? 'bg-green-100 text-green-800' :
                                  choice.status === 'Cancelled' ? 'bg-red-100 text-red-800' :
                                  'bg-gray-100 text-gray-800'
                                }`}>
                                  {choice.status}
                                </div>
                              </div>
                              
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                                <div>
                                  <span className="text-gray-500">Contact:</span>
                                  <div className="font-medium">
                                    {choice.contactType === 'Guest' 
                                      ? choice.guest?.guestName || 'Unknown Guest'
                                      : choice.reference?.name || 'Unknown Reference'
                                    }
                                  </div>
                                  <div className="text-gray-500 text-xs">
                                    {choice.contactType === 'Guest' 
                                      ? choice.guest?.phoneNo
                                      : choice.reference?.phoneNumber
                                    }
                                  </div>
                                </div>
                                <div>
                                  <span className="text-gray-500">Items:</span>
                                  <div className="font-medium">{choice.totalItems || choice.items?.length || 0} items</div>
                                  <div className="text-gray-500 text-xs">
                                    Created {(() => { const d = new Date(choice.createdAt); return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`; })()}
                                  </div>
                                  {choice.items && choice.items.length > 0 && (
                                    <div className="text-gray-500 text-xs mt-1">
                                      {choice.items.some(item => item.calculationType === 'pcsPerBox') && (
                                        <span className="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 mr-1">
                                          Box/Pcs Items
                                        </span>
                                      )}
                                      {choice.items.some(item => item.calculationType !== 'pcsPerBox') && (
                                        <span className="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                          Regular Items
                                        </span>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>

                              {choice.paymentRemark && (
                                <div className="mt-2 p-2 bg-gray-50 rounded text-xs text-gray-600">
                                  <span className="font-medium">Remark:</span> {choice.paymentRemark}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Load More Button */}
                {choicePage < totalChoicePages && !loadingChoices && (
                  <div className="text-center mt-6">
                    <button
                      onClick={() => {
                        const nextPage = choicePage + 1;
                        setChoicePage(nextPage);
                        loadChoices(nextPage, choiceSearch);
                      }}
                      className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
                    >
                      Load More Choices
                    </button>
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className="border-t border-gray-200 px-6 py-4 bg-gray-50 flex justify-between items-center">
                <div className="text-sm text-gray-600">
                  {selectedChoices.length > 0 && (
                    <span>
                      {selectedChoices.length} choice(s) selected • 
                      {selectedChoices.reduce((total, choice) => total + (choice.totalItems || choice.items?.length || 0), 0)} total items
                    </span>
                  )}
                </div>
                <div className="flex gap-3">
                  <button
                    onClick={() => setShowChoiceImportModal(false)}
                    className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={importChoicesAsSection}
                    disabled={selectedChoices.length === 0 || !importingSectionName.trim() || loadingChoices}
                    className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
                  >
                    {loadingChoices ? (
                      <>
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                        Importing...
                      </>
                    ) : (
                      <>
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                        </svg>
                        Import Selected Choices
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
  
};

// Single export at the end
export default TallyQuotation;